import React, { Component } from 'react'
import axios from "axios";
import { API_BASE_URL, TYPE_SUCCESS, TYPE_FAIL, INTERVAL, OHT_READINGS_PAGENAME, FLOW_READINGS_PAGENAME, PRESSURE_READINGS_PAGENAME, LEVEL_READINGS_PAGENAME } from "assets/constants/Constants";
import { REFRESH_ICON, CAMERA_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import MaterialTable from "material-table";
import Tooltip from '@material-ui/core/Tooltip'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import * as Utils from "lib/utils";
import ShowToast from 'components/ShowToast';
import ReadingListTable from 'views/report/ReportComponent/ReadingListTable';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Select from 'react-select';
import GraphLoader from "components/GraphLoader";
import { LineChartFlowrate, LineChartTotalizer, lineDataTwo, lineDataThree, LineChartTwo, lineDataFour, LevellineChart, WrappedMap,PressurelineChart } from "lib/utils"
import { defaultFormatDateTime, validateBitStatusAlarms, validateIsoDateFormat, defaultFormatDate, getAlarmType171BPT } from "lib/utils"

export class MeterReadingPage extends Component {
    constructor(props) {
        super(props)
        const meterData = this.props.history.location.state;
        this.state = {
            isLoading: true,
            meterData,
            metadata: {},
            meterSiteData: {},
            customerData: {},
            readingList: [],
            readingExcelList: [],
            readingRadarList: [],
            pressureExcelGenerateValue: "" ,
            pressureExcelReadings: [],
            pressureGraphList: [],
            totalizerGraphList: [],
            flowrateGraphList: [],
            readingTotalizerExcelList: [],
            readingFlowrateExcelList: [],
            onnileIconClass: "enable-icon",
            toggleClass: true,
            routeName: "",
            serialNumber: "",
            location: "",
            zone: "",
            subZone: "",
            meterApplicationType: null,
            startDate: moment().startOf('day').toDate(),
            endDate: moment().endOf('day').toDate(),
            dailyStartDate : moment().subtract(7, 'days').startOf('day').toDate(),
            dailyEndDate :moment().endOf('day').toDate(),
            weeklyStartDate : moment().subtract(7, 'weeks').startOf('day').toDate(),
            weeklyEndDate :moment().endOf('day').toDate(),
            monthlyStartDate : moment().subtract(7, 'months').startOf('day').toDate(),
            monthlyEndDate :moment().endOf('day').toDate(),
            maxEndDate: new Date(),
            isSyncVisible: true,
            totalizerGenerateValue: "",
            flowrateGenerateValue: "",
            graphGenerateValue: "",
            levelExcelGenerateValue: "",
            flowTotalizerGraphLoading: false,
            flowFlowrateGraphLoading: false,
            levelrateGraphLoading: false,
            pressurerateLoading: false,
            ohtFlowTotalizerGraphLoading: false,
            ohtFlowFlowrateGraphLoading: false,
            excelAndGraphGenerateOptionList: [
                // { label: "Daily", value: "daily" },
                // { label: "Weekly", value: "weekly" },
                // { label: "Monthly", value: "monthly" },
                { label: "Custom", value: "custom" }
            ],
            flowrateSelectOption: [ { label: "Custom", value: "custom" }],
            totalizerDefaultGenerateValue: "daily",
            flowrateDefaultGenerateValue: "daily",
            pressureDefaultGenerateValue: "daily",
            levelGraphGenerateValue: "daily",
            levelGraphList: [],
            error: {},
            ohtTotalizerGraphList: [],
            ohtFlowrateGraphList: [],
            ohtPressureGraphList: [],
            ohtLevelGraphList: [],
            ohtPressureGenerateValue: "",
            ohtLevelGenerateValue: "",
            monthSelectedValue: "",
            defaultMonthSelectedValue: "ONE",
            monthOptions: [],
            siteId: sessionStorage.getItem('siteId'),
            siteData: [],
            materialtableLoading:true
            
        }

        this.toggleClassInterval = null;
        this.readingInterval = null;
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        const readingData = await this.getReadingData();
        const siteWiseData = await this.getSiteData();
        // this.toggleClassInterval = setInterval(() => {
        //     this.setState({
        //         toggleClass: !this.state.toggleClass,
        //         onnileIconClass: this.state.toggleClass ? "enable-icon" : "disable-icon"
        //     })
        // }, 1000);
        if (this.state.meterData.pageName === FLOW_READINGS_PAGENAME) {
            const totalizerGraphReadingsData = await this.getTotalizerGraphReadingsData();
            const flowrateGraphReadingsData = await this.getFlowrateGraphReadingsData()
            console.log("flowrateGraphReadingsData::",flowrateGraphReadingsData)


            const transformedFlowGraphData = totalizerGraphReadingsData.data.result.map(item => {
                const date = moment(item.date);
                return {
                    x: date.local().format('MMM D'),
                    y: item.readings,
                    date: date.format('YYYY-MM-DD'),
                    hour: date.format('HH:mm:ss'),
                    reading:  item.readings.toFixed(2),
                    fullDate: date.toISOString(),
                    hourOfDay: date.hour(),
                    displayLabel: `${date.format('MMM DD, YYYY HH:mm')} - ${item.readings}`
                };
            });

            const barData = [{
                x: transformedFlowGraphData.map(d => d.x),
                y: transformedFlowGraphData.map(d => d.y),
                type: 'bar',
                marker: { color: '#1f77b4' },
                text: transformedFlowGraphData.map(d =>
                    `${d.reading}`
                ),
                textposition: 'outside',
                textfont: {
                    color: 'black',
                    size: 14,
                    weight: 'bold'
                },
                hoverinfo: 'text',
                hovertext: transformedFlowGraphData.map(d =>
                    `Date: ${d.date}<br>Reading: ${d.reading}`
                )
            }];

            const transformedFlowrateData = flowrateGraphReadingsData.data.result.map(item => {
                const date = moment(item.start_time_stamp);
                return {
                    x: date.local().format('YYYY-MM-DD HH:mm:ss'),
                    y: item.flowrate_value
                };
            });
        
            const flowratelineData = [{
                x: transformedFlowrateData.map(d => d.x),
                y: transformedFlowrateData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];
            this.setState({
                totalizerGraphList: barData,
                flowrateGraphList: flowratelineData,
            })
        }
        if (this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME) {
            const pressureGraphReadingsData = await this.getPressuerGraphReadingsData()
            console.log("pressureGraphReadingsData:",pressureGraphReadingsData)
         
            const transformedPressureData = pressureGraphReadingsData.data.result.map(item => {
                const date = moment(item.start_time_stamp); 
                return {
                    x: date.local().format('YYYY-MM-DD HH:mm:ss'),
                    y: item.pressure_value 
                };
            });

            const pressurelineData = [{
                x: transformedPressureData.map(d => d.x),
                y: transformedPressureData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];
            this.setState({
                pressureGraphList: pressurelineData,
            })
        }
        if (this.state.meterData.pageName === LEVEL_READINGS_PAGENAME) {
            const levelGraphReadingsList = await this.getLevelGraphReadings()
            
            const transformedLevelData = levelGraphReadingsList.data.result.map(item => {
                const date = moment(item.start_time_stamp);
                return {
                    x: date.local().format('YYYY-MM-DD HH:mm:ss'),
                    y: item.level_value
                };
            });

            const levellineData = [{
                x: transformedLevelData.map(d => d.x),
                y: transformedLevelData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];

            this.setState({
                levelGraphList: levellineData,
            })
        }

         if (this.state.meterData.pageName === OHT_READINGS_PAGENAME) {
           const ohtTotalizerGraphReadingsData = await this.getOhtTotalizerGraphReadingsData();
           const ohtFlowrateGraphReadingsData = await this.getOhtFlowrateGraphReadingsData();
           const ohtPressureGraphReadingsData = await this.getOhtPressureGraphReadingsData();
           const ohtLevelGraphReadingsData = await this.getOhtLevelGraphReadingsData();
         

              const transformedOhtTotalizerData = ohtTotalizerGraphReadingsData.data.result.map(item => ({
                x: item.date,
                y: item.readings
            }));
            const transformedOhtFlowrateData = ohtFlowrateGraphReadingsData.data.result.map(item => ({
                x: item.date,
                y: item.readings
            }));

            const ohtTotalizerlineData = [{
                x: transformedOhtTotalizerData.map(d => d.x),
                y: transformedOhtTotalizerData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];
            const ohtFlowratelineData = [{
                x: transformedOhtFlowrateData.map(d => d.x),
                y: transformedOhtFlowrateData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];

              const transformedOhtPressureData = ohtPressureGraphReadingsData.data.result.map(item => ({
                x: item.date,
                y: item.readings
            }));
            const transformedOhtLevelData = ohtLevelGraphReadingsData.data.result.map(item => ({
                x: item.date,
                y: item.readings
            }));

            const ohtPressurelineData = [{
                x: transformedOhtPressureData.map(d => d.x),
                y: transformedOhtPressureData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];
            const ohtLevellineData = [{
                x: transformedOhtLevelData.map(d => d.x),
                y: transformedOhtLevelData.map(d => d.y),
                type: 'scatter',
                mode: 'lines+markers',
                marker: { color: '#1f77b4' },
                line: { color: '#1f77b4' },
                borderRadius: '45%',
            }];

            this.setState({
                ohtTotalizerGraphList: ohtTotalizerlineData,
                ohtFlowrateGraphList: ohtFlowratelineData,
                ohtPressureGraphList: ohtPressurelineData,
                ohtLevelGraphList: ohtLevellineData
            })
        }

        // this.readingInterval = setInterval(async () => {
        //     const readingData = await this.getReadingData();
        //     this.setState({
        //         readingList: readingData.data.result.readingData,
        //         readingRadarList: readingData.data.result.readingRadarData ? readingData.data.result.readingRadarData : [],
        //         routeName: readingData.data.result.route_name,
        //         serialNumber: readingData.data.result.meter_serial_no,
        //         location: readingData.data.result.location ? readingData.data.result.location : "NA",
        //         zone: readingData.data.result.zone ? readingData.data.result.zone : "NA",
        //         subZone: readingData.data.result.subZone ? readingData.data.result.subZone : "NA",

        //     })
        // }, 5000);

        this.setState({
            metadata: readingData.data.result,
            siteData: siteWiseData.data.result,
            readingList: readingData.data.result.readingData,
            readingRadarList: readingData.data.result.readingRadarData ? readingData.data.result.readingRadarData : [],
            serialNumber: readingData.data.result.meter_serial_no,
            location: readingData.data.result.location ? readingData.data.result.location : "NA",
            zone: readingData.data.result.zone ? readingData.data.result.zone : "NA",
            subZone: readingData.data.result.subZone ? readingData.data.result.subZone : "NA",
            meterApplicationType: readingData.data.result.meter_application_type ? readingData.data.result.meter_application_type : "null",
            isLoading: false,
            materialtableLoading:false
        },() =>{
            console.log("readingList::",this.state.readingList)
        });

        this.generateMonthOptions()
    }

    componentWillUnmount() {
        clearInterval(this.toggleClassInterval);
        clearInterval(this.readingInterval);
        this.toggleClassInterval = null;
        this.readingInterval = null;
    }

    getReadingData = async () => {
        if (this.state.meterData.pageName === "Meter") {
            return await axios(`${API_BASE_URL}/readings/meter/serialnum/${this.state.meterData.rowItem.serial_number}/${this.state.meterData.rowItem.route_id}`);
        }
        else if (this.state.meterData.pageName === "AMI Readings") {
            return await axios(`${API_BASE_URL}/readings/meter/serialnum/${this.state.meterData.rowItem.serial_number}`);
        }
        else if (this.state.meterData.pageName === FLOW_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/flow/readings/meter/serialnum/${this.state.meterData.rowItem.serial_number}`);
        }
        else if (this.state.meterData.pageName === LEVEL_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/level/readings/meter/serialnum/${this.state.meterData.rowItem.serial_number}`);
        }
        else if (this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/pressure/readings/meter/serialnum/${this.state.meterData.rowItem.serial_number}`);
        }
        else if (this.state.meterData.pageName === OHT_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/oht/readings/meter/serialnum/${this.state.meterData.rowItem.serial_number}`);
        }
        else if (this.state.meterData.pageName1 === "Route Meter Mapping") {
            return await axios(`${API_BASE_URL}/readings/meter/serialnum/${this.state.meterData.routeItem.serial_number}/${this.state.meterData.routeItem.route_id}`);
        }
        else {
            return await axios(`${API_BASE_URL}/readings/meter/serialnum/${this.state.meterData.serial_number}`);
        }
    }

    getSiteData = async () => {
        return await axios(`${API_BASE_URL}/one/site/${this.state.siteId}`);
    }

    getTotalizerGraphReadingsData = async () => {
        if (this.state.meterData.pageName === FLOW_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/flow/readings/totalizer/graph/${this.state.meterData.rowItem.serial_number}/${this.state.totalizerDefaultGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}/${this.state.defaultMonthSelectedValue.value}}`)
        }
    }

    getFlowrateGraphReadingsData = async () => {
        if (this.state.meterData.pageName === FLOW_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/flow/readings/flowrate/graph/${this.state.meterData.rowItem.serial_number}/${this.state.flowrateDefaultGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`)
        }
    }

    getOhtTotalizerGraphReadingsData = async () => {
        if (this.state.meterData.pageName === OHT_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/oht/readings/totalizer/graph/${this.state.meterData.rowItem.serial_number}/${this.state.totalizerDefaultGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`)
        }
    }

    getOhtFlowrateGraphReadingsData = async () => {
        if (this.state.meterData.pageName === OHT_READINGS_PAGENAME ) {
            return await axios(`${API_BASE_URL}/oht/readings/flowrate/graph/${this.state.meterData.rowItem.serial_number}/${this.state.flowrateDefaultGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`)
        }
    }

    getOhtPressureGraphReadingsData = async () =>{
        if (this.state.meterData.pageName === OHT_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/oht/pressure/readings/graph/${this.state.meterData.rowItem.serial_number}/${this.state.pressureDefaultGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`)
        }
    }


    getOhtLevelGraphReadingsData = async () =>{
        if (this.state.meterData.pageName === OHT_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/oht/level/readings/graph/${this.state.meterData.rowItem.serial_number}/${this.state.levelGraphGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`)
        }
    }

    getLevelGraphReadings = async () => {
        if (this.state.meterData.pageName === LEVEL_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/level/readings/graph/${this.state.meterData.rowItem.serial_number}/${this.state.levelGraphGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
        }
    }

    getPressuerGraphReadingsData = async () => {
        if (this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME) {
            return await axios(`${API_BASE_URL}/pressure/readings/graph/${this.state.meterData.rowItem.serial_number}/${this.state.pressureDefaultGenerateValue}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`)
        }
    }


    renderStatus = (item) => {
        if (this.state.meterData.pageName === "Meter") {
            if (this.state.meterData.rowItem.serial_number === item) {
                return this.state.meterData.rowItem.status;
            }
        }
        else if (this.state.meterData.pageName1 === "Route Meter Mapping") {
            if (this.state.meterData.routeItem.serial_number === item) {
                return this.state.meterData.routeItem.status;
            }
        }
        else if (this.state.meterData.serial_number === item) {
            return this.state.meterData.status;
        }
    }

      generateMonthOptions() {
        const months = [];
        const currentDate = new Date();

        for (let i = 0; i < 12; i++) {
            const date = new Date();
            date.setMonth(currentDate.getMonth() - i);

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const monthName = date.toLocaleString('default', { month: 'long' });

            const value = `${year}-${month}`;
            const label = `${monthName} ${year}`;

            months.push({ value, label });
        }

        this.setState({ monthOptions: months });
    }

    routeMeterMapping = (item) => {
        const rowItem = {
            _id: item.routeItem.route_id,
            site_id: item.routeItem.site_id,
            route_name: this.state.routeName,
            street: item.routeItem.street,
            city: item.routeItem.city,
            pin_code: item.routeItem.pin_code,
        }
        if (this.props.history.location.state.pageName === "Route Master") {
            this.props.history.push({
                pathname: "/route-meter-mapping",
                state: { rowItem, isVisibleAddMeter: true, pageName: "Route Master", pathName: "master-route-page", pageName1: "Route Meter Mapping" }
            });
        }
        else if (this.props.history.location.state.pageName === "Route Transaction") {
            this.props.history.push({
                pathname: "/route-meter-mapping",
                state: { rowItem, isVisibleAddMeter: true, pageName: "Route Transaction", pathName: "route-transaction-page", pageName1: "Route Meter Mapping" }
            });
        }
        else if (this.props.history.location.state.pageName === "Route Collection History") {
            this.props.history.push({
                pathname: "/route-meter-mapping",
                state: { rowItem, isVisibleAddMeter: true, pageName: "Route History", pathName: "route-history", pageName1: "Route Meter Mapping" }
            });
        }
    }

    isFormTotalizerValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.totalizerGenerateValue) {
            isValid = false;
            error.totalizerGenerateValue = "Please select report generate date";
        }
        if (this.state.totalizerGenerateValue.label === "Monthly") {
            if (!this.state.monthSelectedValue) {
                isValid = false;
                error.monthSelectedValue = "Please select month";
            }
        }

        this.setState({
            error
        });

        return isValid;
    }

    isFormFlowrateValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.flowrateGenerateValue) {
            isValid = false;
            error.flowrateGenerateValue = "Please select report generate date";
        }
        this.setState({
            error
        });

        return isValid;
    }

    isFormLevelValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.levelExcelGenerateValue) {
            isValid = false;
            error.levelExcelGenerateValue = "Please select report generate date";
        }
        this.setState({
            error
        });

        return isValid;
    }

    isFormPressureValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.pressureExcelGenerateValue) {
            isValid = false;
            error.pressureExcelGenerateValue = "Please select report generate date";
        }
        this.setState({
            error
        });

        return isValid;
    }

    getTotalizerReportReadings = async () => {
        if (this.isFormTotalizerValid()) {
            try {
                this.setState({
                    readingTotalizerExcelList: [],
                    isSyncVisible: false,
                    flowTotalizerGraphLoading: true
                });
                let interval = 10000;

                if (this.toggleClassInterval && this.toggleClassInterval) {
                    Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                    clearInterval(this.toggleClassInterval);
                    clearInterval(this.readingInterval);
                    this.toggleClassInterval = null;
                    this.readingInterval = null;
                }
                else {
                    interval = 0;
                }

                setTimeout(async () => {
                    // Utils.showLoading("Fetching report data...");
                    //const readingData = await axios(`${API_BASE_URL}/flow/readings/totalizer/${this.state.meterData.rowItem.serial_number}/${this.state.totalizerGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                   const graphReadingsData = await axios.get(`${API_BASE_URL}/flow/readings/totalizer/graph/${this.state.meterData.rowItem.serial_number}/${this.state.totalizerGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}/${this.state.monthSelectedValue.value}`);
                    Utils.hideLoading();
                    if (graphReadingsData.data.result.length > 0) {
                        ShowToast(`Report created successfully ${this.state.metadata.meter_serial_no}`, TYPE_SUCCESS, INTERVAL, null, "");
                        var excelDownloadBtn = document.getElementById("download-excel-button-totalizer");
                        if (excelDownloadBtn) {
                            excelDownloadBtn.classList.add("mystyle");
                        }

                        let transformedFlowGraphData;
                        let barData;
                        if (this.state.totalizerGenerateValue.label === "Daily" || this.state.totalizerGenerateValue.label === "Monthly") {
                            transformedFlowGraphData = graphReadingsData.data.result.map(item => {
                                const date = moment(item.date);
                                return {
                                    x: date.local().format('MMM D'),
                                    y: item.readings,
                                    date: date.format('YYYY-MM-DD'),
                                    hour: date.format('HH:mm:ss'),
                                    reading: item.readings.toFixed(2),
                                    fullDate: date.toISOString(),
                                    hourOfDay: date.hour(),
                                    displayLabel: `${date.format('MMM DD, YYYY HH:mm')} - ${item.readings}`
                                };
                            });

                            barData = [{
                                x: transformedFlowGraphData.map(d => d.x),
                                y: transformedFlowGraphData.map(d => d.y),
                                type: 'bar',
                                marker: { color: '#1f77b4' },
                                text: transformedFlowGraphData.map(d =>
                                    `${d.reading}`
                                ),
                                textfont: {
                                    color: 'black',
                                    size: 14,
                                    weight: 'bold'
                                },
                                textposition: 'outside',
                                hoverinfo: 'text',
                                hovertext: transformedFlowGraphData.map(d =>
                                    `Date: ${d.date}<br>Reading: ${d.reading}`
                                )
                            }];
                        }
                        else if (this.state.totalizerGenerateValue.label === "Custom") {
                            transformedFlowGraphData = graphReadingsData.data.result.map(item => {
                                return {
                                    x: item.metersSerailNumber, 
                                    y: item.meterConsumptionDifference || item.readings, 
                                    meterSerial: item.metersSerailNumber,
                                    reading: item.meterConsumptionDifference.toFixed(2) || item.readings.toFixed(2),
                                    location: item.location,
                                    subzone: item.subzone,
                                    zone: item.zone,
                                    fromDate: item.fromDate,
                                    toDate: item.toDate,
                                    displayLabel: `${item.metersSerailNumber} - ${item.meterConsumptionDifference || item.readings}`
                                };
                            });

                            barData = [{
                                x: transformedFlowGraphData.map(d => d.x),
                                y: transformedFlowGraphData.map(d => d.y),
                                type: 'bar',
                                marker: { color: '#1f77b4' },
                                text: transformedFlowGraphData.map(d => `${d.reading}`),
                                textfont: {
                                    size: 6
                                },
                                textposition: 'outside',
                                hoverinfo: 'text',
                                hovertext: transformedFlowGraphData.map(d =>
                                    `Meter: ${d.meterSerial}<br>Reading: ${d.reading}<br>Location: ${d.location}<br>Period: ${moment(d.fromDate).format('MMM DD')} - ${moment(d.toDate).format('MMM DD')}`
                                )
                            }];
                        }
                        this.setState({
                            readingTotalizerExcelList: graphReadingsData.data.result,
                            totalizerGraphList: barData,
                            isSyncVisible: true,
                            flowTotalizerGraphLoading: false
                        });

                    }
                    else {
                        ShowToast('There is no data to fetch!', TYPE_SUCCESS, INTERVAL, null, "");
                    }
                }, interval);
            } catch (error) {
                ShowToast('Something went wrong.', TYPE_FAIL, INTERVAL, null, "");
                Utils.hideLoading();
            }
        }
    }
    getFlowrateReportReadings = async () => {
        if (this.isFormFlowrateValid()) {
            try {
                this.setState({
                    readingFlowrateExcelList: [],
                    isSyncVisible: false,
                    flowFlowrateGraphLoading: true,
                });
                let interval = 10000;

                if (this.toggleClassInterval && this.toggleClassInterval) {
                    Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                    clearInterval(this.toggleClassInterval);
                    clearInterval(this.readingInterval);
                    this.toggleClassInterval = null;
                    this.readingInterval = null;
                }
                else {
                    interval = 0;
                }

                setTimeout(async () => {
                    //const readingData = await axios(`${API_BASE_URL}/flow/readings/flowrate/${this.state.meterData.rowItem.serial_number}/${this.state.flowrateGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                    const graphReadingsData = await axios(`${API_BASE_URL}/flow/readings/flowrate/graph/${this.state.meterData.rowItem.serial_number}/${this.state.flowrateGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                    console.log("graphReadingsData-get-report::",graphReadingsData)
                    Utils.hideLoading();
                    if (graphReadingsData.data.result.length > 0) {
                        ShowToast(`Report created successfully ${this.state.metadata.meter_serial_no}`, TYPE_SUCCESS, INTERVAL, null, "");
                        var excelDownloadBtn = document.getElementById("download-excel-button-flowrate");
                        if (excelDownloadBtn) {
                            excelDownloadBtn.classList.add("mystyle");
                        }

                        const startDate = moment(this.state.startDate);
                        const startdateOnly = startDate.format('YYYY-MM-DD'); 
                        const endDate = moment(this.state.endDate);
                        const enddateOnly = endDate.format('YYYY-MM-DD');

                        let transformedData;
                        let lineData;

                        if (startdateOnly === enddateOnly) {

                            transformedData = graphReadingsData.data.result.map(item => {
                                const date = moment(item.start_time_stamp);
                                return {
                                    x: date.local().format('YYYY-MM-DD HH:mm:ss'),
                                    y: item.flowrate_value
                                };
                            });


                            lineData = [{
                                x: transformedData.map(d => d.x),
                                y: transformedData.map(d => d.y),
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: '#1f77b4' },
                                line: { color: '#1f77b4' },
                                borderRadius: '45%',
                            }];
                        }
                        else {

                            const minTransformedData = graphReadingsData.data.result.map(item => ({
                                x: moment(item.min_start_time_stamp).local().format('YYYY-MM-DD HH:mm:ss'),
                                y: item.min_flowrate_value
                            }));

                            const maxTransformedData = graphReadingsData.data.result.map(item => ({
                                x: moment(item.max_start_time_stamp).local().format('YYYY-MM-DD HH:mm:ss'),
                                y: item.max_flowrate_value
                            }));

                            lineData = [
                                {
                                    x: minTransformedData.map(d => d.x),
                                    y: minTransformedData.map(d => d.y),
                                    type: 'scatter',
                                    mode: 'lines+markers',
                                    marker: { color: '#ff7f0e' },
                                    line: { color: '#ff7f0e' },
                                    name: 'Minimum Flowrate'
                                },
                                {
                                    x: maxTransformedData.map(d => d.x),
                                    y: maxTransformedData.map(d => d.y),
                                    type: 'scatter',
                                    mode: 'lines+markers',
                                    marker: { color: '#d62728' }, 
                                    line: { color: '#d62728' },
                                    name: 'Maximum Flowrate'
                                }
                            ];
                        }
                    
                    
                        this.setState({
                            readingFlowrateExcelList: graphReadingsData.data.result,
                            flowrateGraphList: lineData,
                            isSyncVisible: true,
                            flowFlowrateGraphLoading: false
                        });

                    }
                    else {
                        ShowToast('There is no data to fetch!', TYPE_SUCCESS, INTERVAL, null, "");
                    }
                }, interval);
            } catch (error) {
                ShowToast('Something went wrong.', TYPE_FAIL, INTERVAL, null, "");
                Utils.hideLoading();
            }
        }
    }

    totalizerGenerateChangeHandler = (event) => {
        this.setState({
            totalizerGenerateValue: { label: event.label, value: event.value },
        })
        var excelDownloadBtn = document.getElementById("download-excel-button-totalizer");
        excelDownloadBtn.classList.remove("mystyle");
    }

    monthChangeHandler = (event) => {
        this.setState({
            monthSelectedValue: event
        });
    }

    flowrateGenerateChangeHandler = (event) => {
        this.setState({
            flowrateGenerateValue: { label: event.label, value: event.value },
        })
        // var excelDownloadBtn = document.getElementById("download-excel-button-flowrate");
        // excelDownloadBtn.classList.remove("mystyle");
    }

    levelGenerateChangeHandler = (event) => {
        this.setState({
            levelExcelGenerateValue: { label: event.label, value: event.value },
        })
    }

    pressureGenerateChangeHandler = (event) => {
        this.setState({
            pressureExcelGenerateValue: { label: event.label, value: event.value },
        })
    }

    getAMIReportReadings = async () => {
        try {
            this.setState({
                readingList: [],
                isSyncVisible: false
            });
            let interval = 5000;

            if (this.toggleClassInterval && this.toggleClassInterval) {
                Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                clearInterval(this.toggleClassInterval);
                clearInterval(this.readingInterval);
                this.toggleClassInterval = null;
                this.readingInterval = null;
            }
            else {
                interval = 0;
            }

            setTimeout(async () => {
                //  Utils.showLoading("Fetching report data...");
                const readingData = await axios(`${API_BASE_URL}/readings/ami/${this.state.meterData.rowItem.serial_number}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                Utils.hideLoading();
                if (readingData.data.result.length > 0) {
                    ShowToast(`Report created successfully ${this.state.metadata.meter_serial_no}`, TYPE_SUCCESS, INTERVAL, null, "");
                    var excelDownloadBtn = document.getElementById("download-excel-button");
                    if (excelDownloadBtn) {
                        excelDownloadBtn.classList.add("mystyle");
                    }
                    this.setState({
                        readingList: readingData.data.result
                    });
                }
                else {
                    ShowToast('There is no data to fetch!', TYPE_SUCCESS, INTERVAL, null, "");
                }
            }, interval);
        } catch (error) {
            ShowToast('Something went wrong.', TYPE_FAIL, INTERVAL, null, "");
            Utils.hideLoading();
        }
    }

    exportToXLSXAmiReadings = async () => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Report Data');

            const headersToUse = [
                "Serial Number",
                "Web Receive Time",
                "Route",
                "Gateway",
                "Reader",
                "Unit",
                "Meter Status",
                "Alarm Type",
                "Meter Time",
                "Readings",
                "Photo",
                "RSSI",
                "SSR"
            ];

            const headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Web Receive Time": "created_date_time",
                "Route": "route_name",
                "Gateway": "gway_device_id",
                "Reader": "assigned_user_id",
                "Unit": "unit",
                "Meter Status": "meter_status",
                "Alarm Type": "alarm_type",
                "Meter Time": "receive_date_time",
                "Readings": "meter_reading",
                "Photo": "reading_image",
                "RSSI": "field_strength_rssi",
                "SSR": "snr"
            };

            const dateFormatArray = ["created_date_time"];
            function unitConversion(value) {
                if (value === "0" || value === "m³") {
                    return "m³";
                }
                else if (value === "1" || value === "L") {
                    return "L"
                }
                else if (value === "2" || value === "GAL") {
                    return "GAL"
                }
                else if (value === "3" || value === "ft3") {
                    return "ft3"
                }
                else {
                    return "NA";
                }
            }

            const headerRow = worksheet.addRow(headersToUse);
            headerRow.eachCell((cell) => {
                cell.font = { bold: true, color: "red" };
            });

            this.state.readingList.forEach((row) => {
                const rowData = headersToUse.map(header => {
                    const dataProperty = headerDataMapping[header];
                    if (dateFormatArray.includes(dataProperty)) {
                        const formattedDate = defaultFormatDateTime(row[dataProperty]);
                        return formattedDate !== "Invalid date" ? formattedDate : "NA";
                    } else if (dataProperty === "unit") {
                        return unitConversion(row[dataProperty]);
                    } else {
                        return row[dataProperty] || "NA";
                    }
                });
                worksheet.addRow(rowData);
            });

            const excelBlob = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([excelBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `AMI-meter-report-${moment().format('DD-MM-YYYY hh:mm:ss a')}`);
            var excelDownloadBtn = document.getElementById("download-excel-button");
            excelDownloadBtn.classList.remove("mystyle");
            this.setState({
                startDate: moment().startOf('day').toDate(),
                endDate: moment().endOf('day').toDate(),
            })
        } catch (error) {
            console.error(error);
        }
    };

    getlevelReportReadings = async () => {
        if (this.isFormLevelValid()) {
            try {
                this.setState({
                    levelExcelReadings: [],
                    isSyncVisible: false,
                    levelrateGraphLoading:true,
                });
                let interval = 10000;

                if (this.toggleClassInterval && this.toggleClassInterval) {
                    Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                    clearInterval(this.toggleClassInterval);
                    clearInterval(this.readingInterval);
                    this.toggleClassInterval = null;
                    this.readingInterval = null;
                } else {
                    interval = 0;
                }

                setTimeout(async () => {
                    Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                   // const readinglevelData = await axios(`${API_BASE_URL}/level/readings/excel/${this.state.meterData.rowItem.serial_number}/${this.state.levelExcelGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                    const graphReadingsData = await axios(`${API_BASE_URL}/level/readings/graph/${this.state.meterData.rowItem.serial_number}/${this.state.levelExcelGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                    Utils.hideLoading();
                    if (graphReadingsData.data.result.length > 0) {
                        ShowToast(
                            "Report created successfully",
                            TYPE_SUCCESS,
                            INTERVAL,
                            null,
                            ""
                        );
                        var excelDownloadBtn = document.getElementById(
                            "download-excel-button-level"
                        );
                        if (excelDownloadBtn) {
                            excelDownloadBtn.classList.add("mystyle");
                        }
                        const startDate = moment(this.state.startDate);
                        const startdateOnly = startDate.format('YYYY-MM-DD');
                        const endDate = moment(this.state.endDate);
                        const enddateOnly = endDate.format('YYYY-MM-DD');

                        let transformedData;
                        let levellineData;

                        if (startdateOnly === enddateOnly) {
                            transformedData = graphReadingsData.data.result.map(item => {
                                const date = moment(item.start_time_stamp);
                                return {
                                    x: date.local().format('YYYY-MM-DD HH:mm:ss'),
                                    y: item.level_value
                                };
                            });

                            levellineData = [{
                                x: transformedData.map(d => d.x),
                                y: transformedData.map(d => d.y),
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: '#1f77b4' },
                                line: { color: '#1f77b4' },
                                borderRadius: '45%',
                                name: 'Level Readings'
                            }];
                        }
                        else {
                            const minTransformedData = graphReadingsData.data.result.map(item => ({
                                x: moment(item.min_start_time_stamp).local().format('YYYY-MM-DD HH:mm:ss'),
                                y: item.min_level_value
                            }));

                            const maxTransformedData = graphReadingsData.data.result.map(item => ({
                                x: moment(item.max_start_time_stamp).local().format('YYYY-MM-DD HH:mm:ss'),
                                y: item.max_level_value
                            }));

                            levellineData = [
                                {
                                    x: minTransformedData.map(d => d.x),
                                    y: minTransformedData.map(d => d.y),
                                    type: 'scatter',
                                    mode: 'lines+markers',
                                    marker: { color: '#ff7f0e' },
                                    line: { color: '#ff7f0e' },
                                    name: 'Minimum Level'
                                },
                                {
                                    x: maxTransformedData.map(d => d.x),
                                    y: maxTransformedData.map(d => d.y),
                                    type: 'scatter',
                                    mode: 'lines+markers',
                                    marker: { color: '#d62728' },
                                    line: { color: '#d62728' },
                                    name: 'Maximum Level'
                                }
                            ];
                        }
                
                        this.setState(
                            {
                                levelExcelReadings: graphReadingsData.data.result,
                                levelGraphList: levellineData,
                                levelrateGraphLoading:false,
                            },
                            () => {
                                console.log(
                                    "levelExcelReadings::",
                                    this.state.levelExcelReadings
                                );
                            }
                        );
                    } else {
                        ShowToast(
                            "There is no data to fetch!",
                            TYPE_SUCCESS,
                            INTERVAL,
                            null,
                            ""
                        );
                        this.setState( {
                            levelrateGraphLoading:false
                        } )
                    }
                }, interval);
            } catch (error) {
                ShowToast("Something went wrong.", TYPE_FAIL, INTERVAL, null, "");
                Utils.hideLoading();
            }
        }
    };


    getPressureReportReadings = async () => {
        if (this.isFormPressureValid()) {
            try {
                this.setState({
                    pressureExcelReadings: [],
                    pressureGraphList: [],
                    isSyncVisible: false,
                    pressurerateLoading: true
                });
                let interval = 10000;

                if (this.toggleClassInterval && this.toggleClassInterval) {
                    Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                    clearInterval(this.toggleClassInterval);
                    clearInterval(this.readingInterval);
                    this.toggleClassInterval = null;
                    this.readingInterval = null;
                } else {
                    interval = 0;
                }

                setTimeout(async () => {
                    Utils.showLoading(`Fetching ${this.state.metadata.meter_serial_no} report data...`);
                   //const readinglevelData = await axios(`${API_BASE_URL}/pressure/readings/excel/${this.state.meterData.rowItem.serial_number}/${this.state.pressureExcelGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                    const graphReadingsData = await axios(`${API_BASE_URL}/pressure/readings/graph/${this.state.meterData.rowItem.serial_number}/${this.state.pressureExcelGenerateValue.value}/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}`);
                    console.log("graphReadingsData-pressure",graphReadingsData)
                    Utils.hideLoading();
                    if (graphReadingsData.data.result.length > 0) {
                        ShowToast(
                            "Report created successfully",
                            TYPE_SUCCESS,
                            INTERVAL,
                            null,
                            ""
                        );
                        var excelDownloadBtn = document.getElementById(
                            "download-excel-button-pressure"
                        );
                        if (excelDownloadBtn) {
                            excelDownloadBtn.classList.add("mystyle");
                        }

                        const startDate = moment(this.state.startDate);
                        const startdateOnly = startDate.format('YYYY-MM-DD'); 
                        console.log("startDate", startdateOnly);

                        const endDate = moment(this.state.endDate);
                        const enddateOnly = endDate.format('YYYY-MM-DD');
                        console.log("endDate", enddateOnly);

                        let transformedData;
                        let pressurelineData;

                        if (startdateOnly === enddateOnly) {

                            transformedData = graphReadingsData.data.result.map(item => {
                                const date = moment(item.start_time_stamp);
                                return {
                                    x: date.local().format('YYYY-MM-DD HH:mm:ss'),
                                    y: item.pressure_value
                                };
                            });


                            pressurelineData = [{
                                x: transformedData.map(d => d.x),
                                y: transformedData.map(d => d.y),
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: { color: '#1f77b4' },
                                line: { color: '#1f77b4' },
                                borderRadius: '45%',
                            }];
                        }
                        else {

                            const minTransformedData = graphReadingsData.data.result.map(item => ({
                                x: moment(item.min_start_time_stamp).local().format('YYYY-MM-DD HH:mm:ss'),
                                y: item.min_pressure_value
                            }));

                            const maxTransformedData = graphReadingsData.data.result.map(item => ({
                                x: moment(item.max_start_time_stamp).local().format('YYYY-MM-DD HH:mm:ss'),
                                y: item.max_pressure_value
                            }));

                            pressurelineData = [
                                {
                                    x: minTransformedData.map(d => d.x),
                                    y: minTransformedData.map(d => d.y),
                                    type: 'scatter',
                                    mode: 'lines+markers',
                                    marker: { color: '#ff7f0e' },
                                    line: { color: '#ff7f0e' },
                                    name: 'Minimum Pressure'
                                },
                                {
                                    x: maxTransformedData.map(d => d.x),
                                    y: maxTransformedData.map(d => d.y),
                                    type: 'scatter',
                                    mode: 'lines+markers',
                                    marker: { color: '#d62728' }, 
                                    line: { color: '#d62728' },
                                    name: 'Maximum Pressure'
                                }
                            ];
                        }
                    
                        this.setState(
                            {
                                pressureExcelReadings: graphReadingsData.data.result,
                                pressureGraphList: pressurelineData,
                                pressurerateLoading: false,
                            },
                            () => {
                                console.log(
                                    "PressureExcelReadings::",
                                    this.state.pressureExcelReadings
                                );
                            }
                        );
                    } else {
                        ShowToast(
                            "There is no data to fetch!",
                            TYPE_SUCCESS,
                            INTERVAL,
                            null,
                            ""
                        );
                        this.setState({pressurerateLoading:false})
                        this.setState({pressureExcelGenerateValue:""})
                    }
                }, interval);
            } catch (error) {
                ShowToast("Something went wrong.", TYPE_FAIL, INTERVAL, null, "");
                Utils.hideLoading();
            }
        }
    };

totalizerExportToXLSX = async () => {
    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Report Data');

        let siteData = this.state.siteData;

        const detectImageFormat = (base64Data) => {
            if (base64Data.startsWith('/9j/') || base64Data.startsWith('/9j/4AAQ')) {
                return 'jpeg';
            } else if (base64Data.startsWith('iVBORw0KGgo')) {
                return 'png';
            } else {
                return 'png';
            }
        };

        let currentRow = 5;

        if (siteData) {
            if (siteData.client_logoImage_primary && siteData.client_logoImage_primary.base64Data) {
                const imageFormat = detectImageFormat(siteData.client_logoImage_primary.base64Data);
                const imageId = workbook.addImage({
                    base64: siteData.client_logoImage_primary.base64Data,
                    extension: imageFormat,
                });
                
                worksheet.addImage(imageId, {
                    tl: { col: 0, row: 0 },
                    br: { col: 2, row: 4 }
                });
            }

            if (siteData.client_logoImage_secondary && siteData.client_logoImage_secondary.base64Data) {
                const imageFormat = detectImageFormat(siteData.client_logoImage_secondary.base64Data);
                const imageId2 = workbook.addImage({
                    base64: siteData.client_logoImage_secondary.base64Data,
                    extension: imageFormat,
                });
                
                worksheet.addImage(imageId2, {
                    tl: { col: 6, row: 0 }, 
                    br: { col: 8, row: 4 }  
                });
            }

            const titleRow1 = worksheet.getRow(1);
            const titleRow2 = worksheet.getRow(2);
            const titleRow3 = worksheet.getRow(3);
            
            worksheet.mergeCells('C1:E1');
            worksheet.mergeCells('C2:E2');
            worksheet.mergeCells('C3:E3');
            
            const titleCell1 = worksheet.getCell('C1');
            titleCell1.value = siteData.client_name || 'Client Name';
            titleCell1.font = { bold: true, size: 16 };
            titleCell1.alignment = { horizontal: 'center', vertical: 'middle' };
            
            const titleCell2 = worksheet.getCell('C2');
            titleCell2.value = siteData.site_name || 'Site Name';
            titleCell2.font = { bold: true, size: 14 };
            titleCell2.alignment = { horizontal: 'center', vertical: 'middle' };
            
            const titleCell3 = worksheet.getCell('C3');
            let dateText = "";
            
            if (this.state.totalizerGenerateValue.label === "Daily") {
                dateText = `Daily Report: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;
            } else if (this.state.totalizerGenerateValue.label === "Monthly") {
                dateText = `Monthly Report: ${this.state.monthSelectedValue.value} | Generated: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;
            } else if (this.state.totalizerGenerateValue.label === "Custom") {
                dateText = `Custom Report: ${defaultFormatDate(this.state.startDate)} To: ${defaultFormatDate(this.state.endDate)} | Generated: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;
            }
            
            titleCell3.value = dateText;
            titleCell3.font = { size: 12 };
            titleCell3.alignment = { horizontal: 'center', vertical: 'middle' };
            
            for (let row = 1; row <= 3; row++) {
                for (let col = 1; col <= 8; col++) {
                    const cell = worksheet.getCell(row, col);
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                    
                    if (col >= 3 && col <= 5) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFF0F0F0' }
                        };
                    }
                }
            }
        }

        let headersToUse;
        let headerDataMapping;
        
        if (this.state.totalizerGenerateValue.label === "Daily" || this.state.totalizerGenerateValue.label === "Monthly") {
            headersToUse = [
                "Serial Number",
                "Zone",
                "Subzone",
                "Location",
                "Date",
                "Consumption",
                "Report Generated Date And Time"
            ];

            headerDataMapping = {
                "Serial Number": "meterSerialNumber",
                "Zone": "zone",
                "Subzone": "subZone",
                "Location": "location",
                "Date": "date",
                "Consumption": "readings",
                "Report Generated Date And Time": "reportGeneratedDate"
            };
        } else if (this.state.totalizerGenerateValue.label === "Custom") {
            headersToUse = [
                "Serial Number",
                "Zone",
                "Subzone",
                "Location",
                "From Date",
                "From Date Readings",
                "To Date",
                "To Date Readings",
                "Total Flow (Consumption)",
                "Report Generated Date And Time"
            ];

            headerDataMapping = {
                "Serial Number": "metersSerailNumber",
                "Zone": "zone",
                "Subzone": "subzone",
                "Location": "location",
                "From Date": "fromDate",
                "From Date Readings": "meterFromValue",
                "To Date": "toDate",
                "To Date Readings": "meterToValue",
                "Total Flow (Consumption)": "meterConsumptionDifference",
                "Report Generated Date And Time": "reportGeneratedDate"
            };
        }

        const dateFormatArray = ["timeStamp","startTimeStamp","networkTimeStamp","date","reportGeneratedDate","fromDate","toDate"];
        
        function unitConversion(value) {
            if (value === "0" || value === "m³") {
                return "m³";
            } else if (value === "1" || value === "L") {
                return "L";
            } else if (value === "2" || value === "GAL") {
                return "GAL";
            } else if (value === "3" || value === "ft3") {
                return "ft3";
            } else {
                return "NA";
            }
        }

        const headerRow = worksheet.getRow(currentRow);
        headersToUse.forEach((header, index) => {
            const cell = headerRow.getCell(index + 1);
            cell.value = header;
            cell.font = { bold: true, color: "red" };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
        
        currentRow++;

        this.state.readingTotalizerExcelList.forEach((row) => {
            const rowData = headersToUse.map(header => {
                const dataProperty = headerDataMapping[header];
                if (dateFormatArray.includes(dataProperty)) {
                    const formattedDate = defaultFormatDateTime(row[dataProperty]);
                    return formattedDate !== "Invalid date" ? formattedDate : "NA";
                } else if (dataProperty === "unit") {
                    return unitConversion(row[dataProperty]);
                } else {
                    return row[dataProperty] || 0;
                }
            });
            
            const dataRow = worksheet.getRow(currentRow);
            rowData.forEach((value, index) => {
                const cell = dataRow.getCell(index + 1);
                cell.value = value;
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
            
            currentRow++;
        });

        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const columnLength = cell.value ? cell.value.toString().length : 10;
                if (columnLength > maxLength) {
                    maxLength = columnLength;
                }
            });
            column.width = Math.min(maxLength < 10 ? 10 : maxLength + 2, 50); 
        });

        worksheet.properties.defaultColWidth = 15;

        const excelBlob = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([excelBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${this.state.meterData.pageName === FLOW_READINGS_PAGENAME ? "Flow" : "Readings"}-meter-readings-report-totalizer-${this.state.metadata.meter_serial_no}-${this.state.totalizerGenerateValue.value === "custom" ? `From ${defaultFormatDate(this.state.startDate)} To ${defaultFormatDate(this.state.endDate)}` : this.state.totalizerGenerateValue.value} ${moment().format('DD-MM-YYYY hh:mm:ss a')}`);
        
        this.setState({ totalizerGenerateValue: "", onnileIconClass: "enable-icon" });
        const readingData = await this.getReadingData();
        this.setState({ readingList: readingData.data.result.readingData, totalizerGenerateValue: "" });
        
        var excelDownloadBtn = document.getElementById("download-excel-button-totalizer");
        if (excelDownloadBtn) {
            excelDownloadBtn.classList.remove("mystyle");
        }
    } catch (error) {
        console.error(error);
    }
};
flowrateExportToXLSX = async () => {
    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Report Data');

        let siteData = this.state.siteData;

        const detectImageFormat = (base64Data) => {
            if (base64Data.startsWith('/9j/') || base64Data.startsWith('/9j/4AAQ')) {
                return 'jpeg';
            } else if (base64Data.startsWith('iVBORw0KGgo')) {
                return 'png';
            } else {
                return 'png';
            }
        };

        let currentRow = 5;

        if (siteData) {
            if (siteData.client_logoImage_primary && siteData.client_logoImage_primary.base64Data) {
                const imageFormat = detectImageFormat(siteData.client_logoImage_primary.base64Data);
                const imageId = workbook.addImage({
                    base64: siteData.client_logoImage_primary.base64Data,
                    extension: imageFormat,
                });
                
                worksheet.addImage(imageId, {
                    tl: { col: 0, row: 0 },
                    br: { col: 2, row: 4 }
                });
            }

            if (siteData.client_logoImage_secondary && siteData.client_logoImage_secondary.base64Data) {
                const imageFormat = detectImageFormat(siteData.client_logoImage_secondary.base64Data);
                const imageId2 = workbook.addImage({
                    base64: siteData.client_logoImage_secondary.base64Data,
                    extension: imageFormat,
                });
                
                worksheet.addImage(imageId2, {
                    tl: { col: 6, row: 0 }, 
                    br: { col: 8, row: 4 }  
                });
            }

            const titleRow1 = worksheet.getRow(1);
            const titleRow2 = worksheet.getRow(2);
            const titleRow3 = worksheet.getRow(3);
            
            worksheet.mergeCells('C1:E1');
            worksheet.mergeCells('C2:E2');
            worksheet.mergeCells('C3:E3');
            
            const titleCell1 = worksheet.getCell('C1');
            titleCell1.value = siteData.client_name || 'Client Name';
            titleCell1.font = { bold: true, size: 16 };
            titleCell1.alignment = { horizontal: 'center', vertical: 'middle' };
            
            const titleCell2 = worksheet.getCell('C2');
            titleCell2.value = siteData.site_name || 'Site Name';
            titleCell2.font = { bold: true, size: 14 };
            titleCell2.alignment = { horizontal: 'center', vertical: 'middle' };
            
            const titleCell3 = worksheet.getCell('C3');
            let dateText = "";
            
            if (this.state.flowrateGenerateValue.label === "Daily") {
                dateText = `Daily Report: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;
            } else if (this.state.flowrateGenerateValue.label === "Monthly") {
                dateText = `Monthly Report: ${this.state.monthSelectedValue.value} | Generated: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;
            } else if (this.state.flowrateGenerateValue.label === "Custom") {
                dateText = `Custom: ${defaultFormatDate(this.state.startDate)} To: ${defaultFormatDate(this.state.endDate)} | Generated: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;
            }
            
            titleCell3.value = dateText;
            titleCell3.font = { size: 12 };
            titleCell3.alignment = { horizontal: 'center', vertical: 'middle' };
            
            for (let row = 1; row <= 3; row++) {
                for (let col = 1; col <= 8; col++) {
                    const cell = worksheet.getCell(row, col);
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                    
                    if (col >= 3 && col <= 5) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFF0F0F0' }
                        };
                    }
                }
            }
        }

        let headersToUse;
        let headerDataMapping;

        const startDate = moment(this.state.startDate);
        const startdateOnly = startDate.format('YYYY-MM-DD');
        const endDate = moment(this.state.endDate);
        const enddateOnly = endDate.format('YYYY-MM-DD');

        if (startdateOnly === enddateOnly) {
            headersToUse = [
                "Serial Number",
                "Meter Date And Time",
                "Flowrate",
                "Status",
            ];

            headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Meter Date And Time": "start_time_stamp",
                "Flowrate": "flowrate_value",
                "Status": "status",
            };
        } else {
            headersToUse = [
                "Serial Number",
                "Min Flowrate",
                "Min Flowrate Date and Time",
                "Min status",
                "Max Flowrate",
                "Max Flowrate Date and Time",
                "Max status",
            ];

            headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Min Flowrate": "min_flowrate_value",
                "Min Flowrate Date and Time": "min_start_time_stamp",
                "Min status": "min_flowrate_status",
                "Max Flowrate": "max_flowrate_value",
                "Max Flowrate Date and Time": "max_start_time_stamp",
                "Max status": "max_flowrate_status",
            };
        }

        const dateFormatArray = ["timeStamp","startTimeStamp","networkTimeStamp","min_start_time_stamp","max_start_time_stamp","start_time_stamp"];
        
        function unitConversion(value) {
            if (value === "0" || value === "m³") {
                return "m³";
            } else if (value === "1" || value === "L") {
                return "L";
            } else if (value === "2" || value === "GAL") {
                return "GAL";
            } else if (value === "3" || value === "ft3") {
                return "ft3";
            } else {
                return "NA";
            }
        }

        const headerRow = worksheet.getRow(currentRow);
        headersToUse.forEach((header, index) => {
            const cell = headerRow.getCell(index + 1);
            cell.value = header;
            cell.font = { bold: true, color: "red" };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
        
        currentRow++;

        this.state.readingFlowrateExcelList.forEach((row) => {
            const rowData = headersToUse.map(header => {
                const dataProperty = headerDataMapping[header];
                if (dateFormatArray.includes(dataProperty)) {
                    const formattedDate = defaultFormatDateTime(row[dataProperty]);
                    return formattedDate !== "Invalid date" ? formattedDate : "NA";
                } else if (dataProperty === "unit") {
                    return unitConversion(row[dataProperty]);
                } else {
                    return row[dataProperty] || 0;
                }
            });
            
            const dataRow = worksheet.getRow(currentRow);
            rowData.forEach((value, index) => {
                const cell = dataRow.getCell(index + 1);
                cell.value = value;
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
            
            currentRow++;
        });

        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const columnLength = cell.value ? cell.value.toString().length : 10;
                if (columnLength > maxLength) {
                    maxLength = columnLength;
                }
            });
            column.width = Math.min(maxLength < 10 ? 10 : maxLength + 2, 50); 
        });

        worksheet.properties.defaultColWidth = 15;

        const excelBlob = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([excelBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${this.state.meterData.pageName === FLOW_READINGS_PAGENAME ? "Flow" : "Readings"}-meter-readings-report-flowrate-${this.state.metadata.meter_serial_no}-${this.state.flowrateGenerateValue.value === "custom" ? `From ${defaultFormatDate(this.state.startDate)} To ${defaultFormatDate(this.state.endDate)}` : this.state.flowrateGenerateValue.value} ${moment().format('DD-MM-YYYY hh:mm:ss a')}`);
        
        this.setState({ flowrateGenerateValue: "", onnileIconClass: "enable-icon" });
        const readingData = await this.getReadingData();
        this.setState({ readingList: readingData.data.result.readingData, flowrateGenerateValue: "" });
        
        var excelDownloadBtn = document.getElementById("download-excel-button-flowrate");
        if (excelDownloadBtn) {
            excelDownloadBtn.classList.remove("mystyle");
        }
    } catch (error) {
        console.error(error);
    }
};


    levelExportToXLSX = async () => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Report Data');

             let siteData = this.state.siteData;

            const detectImageFormat = (base64Data) => {
                if (base64Data.startsWith('/9j/') || base64Data.startsWith('/9j/4AAQ')) {
                    return 'jpeg';
                } else if (base64Data.startsWith('iVBORw0KGgo')) {
                    return 'png';
                } else {
                    return 'png';
                }
            };

            let currentRow = 5;

            if (siteData) {
                if (siteData.client_logoImage_primary && siteData.client_logoImage_primary.base64Data) {
                    const imageFormat = detectImageFormat(siteData.client_logoImage_primary.base64Data);
                    const imageId = workbook.addImage({
                        base64: siteData.client_logoImage_primary.base64Data,
                        extension: imageFormat,
                    });

                    worksheet.addImage(imageId, {
                        tl: { col: 0, row: 0 },
                        br: { col: 2, row: 4 }
                    });
                }

                if (siteData.client_logoImage_secondary && siteData.client_logoImage_secondary.base64Data) {
                    const imageFormat = detectImageFormat(siteData.client_logoImage_secondary.base64Data);
                    const imageId2 = workbook.addImage({
                        base64: siteData.client_logoImage_secondary.base64Data,
                        extension: imageFormat,
                    });

                    worksheet.addImage(imageId2, {
                        tl: { col: 6, row: 0 },
                        br: { col: 8, row: 4 }
                    });
                }

                const titleRow1 = worksheet.getRow(1);
                const titleRow2 = worksheet.getRow(2);
                const titleRow3 = worksheet.getRow(3);

                worksheet.mergeCells('C1:E1');
                worksheet.mergeCells('C2:E2');
                worksheet.mergeCells('C3:E3');

                const titleCell1 = worksheet.getCell('C1');
                titleCell1.value = siteData.client_name || 'Client Name';
                titleCell1.font = { bold: true, size: 16 };
                titleCell1.alignment = { horizontal: 'center', vertical: 'middle' };

                const titleCell2 = worksheet.getCell('C2');
                titleCell2.value = siteData.site_name || 'Site Name';
                titleCell2.font = { bold: true, size: 14 };
                titleCell2.alignment = { horizontal: 'center', vertical: 'middle' };

                const titleCell3 = worksheet.getCell('C3');
                let dateText = `Custom: ${defaultFormatDate(this.state.startDate)} To: ${defaultFormatDate(this.state.endDate)} | Generated: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;

                titleCell3.value = dateText;
                titleCell3.font = { size: 12 };
                titleCell3.alignment = { horizontal: 'center', vertical: 'middle' };

                for (let row = 1; row <= 3; row++) {
                    for (let col = 1; col <= 8; col++) {
                        const cell = worksheet.getCell(row, col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };

                        if (col >= 3 && col <= 5) {
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFF0F0F0' }
                            };
                        }
                    }
                }
            }

            const startDate = moment(this.state.startDate);
            const startdateOnly = startDate.format('YYYY-MM-DD');
            const endDate = moment(this.state.endDate);
            const enddateOnly = endDate.format('YYYY-MM-DD');

            let headersToUse;
            let headerDataMapping;

            if (startdateOnly === enddateOnly) {
                headersToUse = [
                    "Serial Number",
                    "Meter Date And Time",
                    "Level",
                    "Status",
            ];

            headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Meter Date And Time": "start_time_stamp",
                "Level": "level_value",
                "Status": "NA",
            };
        } else {
            headersToUse = [
                "Serial Number",
                "Min Level",
                "Min Level Date and Time",
                "Min Level status",
                "Max Level",
                "Max Level Date and Time",
                "Max Level status",
            ];

            headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Min Level": "min_level_value",
                "Min Level Date and Time": "min_start_time_stamp",
                "Min Level status": "High",
                "Max Level": "max_level_value",
                "Max Level Date and Time": "max_start_time_stamp",
                "Max Level status": "High",
            };
        }

        const dateFormatArray = ["created_date_time", "start_time_stamp", "network_time_stamp", "min_start_time_stamp", "max_start_time_stamp"];
        
        const headerRow = worksheet.getRow(currentRow);
        headersToUse.forEach((header, index) => {
            const cell = headerRow.getCell(index + 1);
            cell.value = header;
            cell.font = { bold: true, color: "red" };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
        
        currentRow++;

        this.state.levelExcelReadings.forEach((row) => {
            const rowData = headersToUse.map(header => {
                const dataProperty = headerDataMapping[header];
                if (dateFormatArray.includes(dataProperty)) {
                    const formattedDate = defaultFormatDateTime(row[dataProperty]);
                    return formattedDate !== "Invalid date" ? formattedDate : "NA";
                }  else {
                    return row[dataProperty] || 0;
                }
            });
            
            const dataRow = worksheet.getRow(currentRow);
            rowData.forEach((value, index) => {
                const cell = dataRow.getCell(index + 1);
                cell.value = value;
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
            
            currentRow++;
        });

        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const columnLength = cell.value ? cell.value.toString().length : 10;
                if (columnLength > maxLength) {
                    maxLength = columnLength;
                }
            });
            column.width = Math.min(maxLength < 10 ? 10 : maxLength + 2, 50);
        });

        worksheet.properties.defaultColWidth = 15;

        const excelBlob = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([excelBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${this.state.meterData.pageName === LEVEL_READINGS_PAGENAME ? "Pressure" : "Readings"}-meter-readings-report-${this.state.metadata.meter_serial_no}-${this.state.levelExcelGenerateValue.value === "custom" ? `From ${defaultFormatDate(this.state.startDate)} To ${defaultFormatDate(this.state.endDate)}` : this.state.levelExcelGenerateValue.value} ${moment().format('DD-MM-YYYY hh:mm:ss a')}`);
        
        this.setState({ 
            levelExcelGenerateValue: "", 
        });
        
        var excelDownloadBtn = document.getElementById("download-excel-button-level");
        if (excelDownloadBtn) {
            excelDownloadBtn.classList.remove("mystyle");
        }
        } catch (error) {
            console.error(error);
        }
    };

    pressureExportToXLSX = async () => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Report Data');

            let siteData = this.state.siteData;

            const detectImageFormat = (base64Data) => {
                if (base64Data.startsWith('/9j/') || base64Data.startsWith('/9j/4AAQ')) {
                    return 'jpeg';
                } else if (base64Data.startsWith('iVBORw0KGgo')) {
                    return 'png';
                } else {
                    return 'png';
                }
            };

            let currentRow = 5;

            if (siteData) {
                if (siteData.client_logoImage_primary && siteData.client_logoImage_primary.base64Data) {
                    const imageFormat = detectImageFormat(siteData.client_logoImage_primary.base64Data);
                    const imageId = workbook.addImage({
                        base64: siteData.client_logoImage_primary.base64Data,
                        extension: imageFormat,
                    });

                    worksheet.addImage(imageId, {
                        tl: { col: 0, row: 0 },
                        br: { col: 2, row: 4 }
                    });
                }

                if (siteData.client_logoImage_secondary && siteData.client_logoImage_secondary.base64Data) {
                    const imageFormat = detectImageFormat(siteData.client_logoImage_secondary.base64Data);
                    const imageId2 = workbook.addImage({
                        base64: siteData.client_logoImage_secondary.base64Data,
                        extension: imageFormat,
                    });

                    worksheet.addImage(imageId2, {
                        tl: { col: 6, row: 0 },
                        br: { col: 8, row: 4 }
                    });
                }

                const titleRow1 = worksheet.getRow(1);
                const titleRow2 = worksheet.getRow(2);
                const titleRow3 = worksheet.getRow(3);

                worksheet.mergeCells('C1:E1');
                worksheet.mergeCells('C2:E2');
                worksheet.mergeCells('C3:E3');

                const titleCell1 = worksheet.getCell('C1');
                titleCell1.value = siteData.client_name || 'Client Name';
                titleCell1.font = { bold: true, size: 16 };
                titleCell1.alignment = { horizontal: 'center', vertical: 'middle' };

                const titleCell2 = worksheet.getCell('C2');
                titleCell2.value = siteData.site_name || 'Site Name';
                titleCell2.font = { bold: true, size: 14 };
                titleCell2.alignment = { horizontal: 'center', vertical: 'middle' };

                const titleCell3 = worksheet.getCell('C3');
                let dateText = `Custom: ${defaultFormatDate(this.state.startDate)} To: ${defaultFormatDate(this.state.endDate)} | Generated: ${moment().format('DD-MM-YYYY hh:mm:ss a')}`;

                titleCell3.value = dateText;
                titleCell3.font = { size: 12 };
                titleCell3.alignment = { horizontal: 'center', vertical: 'middle' };

                for (let row = 1; row <= 3; row++) {
                    for (let col = 1; col <= 8; col++) {
                        const cell = worksheet.getCell(row, col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };

                        if (col >= 3 && col <= 5) {
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFF0F0F0' }
                            };
                        }
                    }
                }
            }

            const startDate = moment(this.state.startDate);
            const startdateOnly = startDate.format('YYYY-MM-DD');
            const endDate = moment(this.state.endDate);
            const enddateOnly = endDate.format('YYYY-MM-DD');

            let headersToUse;
            let headerDataMapping;

            if (startdateOnly === enddateOnly) {
                headersToUse = [
                    "Serial Number",
                    "Meter Date And Time",
                    "Pressure",
                    "Status",
            ];

            headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Meter Date And Time": "start_time_stamp",
                "Pressure": "pressure_value",
                "Status": "status",
            };
        } else {
            headersToUse = [
                "Serial Number",
                "Min Pressure",
                "Min Pressure Date and Time",
                "Min Pressure status",
                "Max Pressure",
                "Max Pressure Date and Time",
                "Max Pressure status",
            ];

            headerDataMapping = {
                "Serial Number": "meter_serial_no",
                "Min Pressure": "min_pressure_value",
                "Min Pressure Date and Time": "min_start_time_stamp",
                "Min Pressure status": "min_pressure_status",
                "Max Pressure": "max_pressure_value",
                "Max Pressure Date and Time": "max_start_time_stamp",
                "Max Pressure status": "max_pressure_status",
            };
        }

        const dateFormatArray = ["created_date_time", "start_time_stamp", "network_time_stamp", "min_start_time_stamp", "max_start_time_stamp"];
        
        const headerRow = worksheet.getRow(currentRow);
        headersToUse.forEach((header, index) => {
            const cell = headerRow.getCell(index + 1);
            cell.value = header;
            cell.font = { bold: true, color: "red" };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
        
        currentRow++;

        this.state.pressureExcelReadings.forEach((row) => {
            const rowData = headersToUse.map(header => {
                const dataProperty = headerDataMapping[header];
                if (dateFormatArray.includes(dataProperty)) {
                    const formattedDate = defaultFormatDateTime(row[dataProperty]);
                    return formattedDate !== "Invalid date" ? formattedDate : "NA";
                }  else {
                    return row[dataProperty] || 0;
                }
            });
            
            const dataRow = worksheet.getRow(currentRow);
            rowData.forEach((value, index) => {
                const cell = dataRow.getCell(index + 1);
                cell.value = value;
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
            
            currentRow++;
        });

        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                const columnLength = cell.value ? cell.value.toString().length : 10;
                if (columnLength > maxLength) {
                    maxLength = columnLength;
                }
            });
            column.width = Math.min(maxLength < 10 ? 10 : maxLength + 2, 50);
        });

        worksheet.properties.defaultColWidth = 15;

        const excelBlob = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([excelBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME ? "Pressure" : "Readings"}-meter-readings-report-${this.state.metadata.meter_serial_no}-${this.state.pressureExcelGenerateValue.value === "custom" ? `From ${defaultFormatDate(this.state.startDate)} To ${defaultFormatDate(this.state.endDate)}` : this.state.pressureExcelGenerateValue.value} ${moment().format('DD-MM-YYYY hh:mm:ss a')}`);
        
        this.setState({ 
            pressureExcelGenerateValue: "", 
        });
        
        var excelDownloadBtn = document.getElementById("download-excel-button-pressure");
        if (excelDownloadBtn) {
            excelDownloadBtn.classList.remove("mystyle");
        }
    } catch (error) {
        console.error(error);
    }
};




    handleStartDateChange = (date) => {
        this.setState({
            startDate: date
        })
    }

    handleEndDateChange = (date) => {
        this.setState({
            endDate: date
        })
    }

    viewImage = (image) => {
        if (image !== "" && image !== undefined) {
            this.setState({ viewImage: true, imgSrc: image })
        }
        else {
            ShowToast("Image not uploaded yet.", TYPE_FAIL, INTERVAL, null, "");
        }
    }
    handleRefresh = async () => {
         this.setState({  materialtableLoading: true})
       const meterreadingsdata = await this.getReadingData(1, this.state.pageSize);
       console.log("meterreadingsdata",meterreadingsdata);
       
         this.setState({
            readingList: meterreadingsdata.data.result.readingData,
              materialtableLoading: false
            })
}

    render() {
        if (this.state.isLoading) {
            return (
                <Spinner />
            )
        }
        else {
            return (
                <div className="main-content">
                    <div className="back">
                        <ul className="breadcrumb1">
                            {
                                this.state.meterData.pageName === "Meter" ? (
                                    <>
                                        <li><a href={this.props.history.location.state.pathName}>{this.props.history.location.state.pageName}</a></li>
                                        <li>Meter Reading</li>
                                    </>
                                ) : (
                                    this.state.meterData.pageName === FLOW_READINGS_PAGENAME || this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME || this.state.meterData.pageName === "AMI Readings" || this.state.meterData.pageName === LEVEL_READINGS_PAGENAME  || this.state.meterData.pageName === OHT_READINGS_PAGENAME ? (
                                        <>
                                            <li><a href={this.props.history.location.state.pathName} >{this.props.history.location.state.pageName}</a></li>
                                            <li>Meter Reading</li>
                                        </>
                                    ) : (
                                        <>
                                            <li><a href={this.props.history.location.state.pathName} >{this.props.history.location.state.pageName}</a></li>
                                            <li><a href={this.props.history.location.state.pathName1} onClick={() => this.routeMeterMapping(this.props.history.location.state)}>{this.props.history.location.state.pageName1}</a></li>
                                            <li>Meter Reading</li>
                                        </>
                                    )
                                )
                            }
                        </ul>
                    </div>
                    <div className="reading-info-outer border">
                        <div className="flow-image-meter-readings">
                            {this.state.meterData.pageName === FLOW_READINGS_PAGENAME ? (
                                <img src="/images/flow-meter.png" alt="Flow Meter" />
                            ) : this.state.meterData.pageName === LEVEL_READINGS_PAGENAME ? (
                                <img src="/images/level-meter.png" alt="Level Meter" />
                            ) : this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME ? (
                                <img src="/images/pressure-meter.png" alt="Pressure Meter" />
                            ) : this.state.meterData.pageName === OHT_READINGS_PAGENAME ? (
                                <img src="/images/oht-meter.png" alt="Oht Meter" />
                            ) : null}
                        </div>
                        <div className="reading-wrapper">
                            <div className="site-wrapper">
                                <div className="row">
                                    <div className="site-info">
                                        <div className="site-content">
                                            <label className="meter-data-header" >Meter Serial No :  </label>
                                            <label className="ml-3">{this.state.serialNumber}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="site-info">
                                        <div className="content">
                                            <label className="meter-data-header" >Meter Location :  </label>
                                            <label className="ml-3">{`${this.state.location}`}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="customer-wrapper">
                                <div className="row">
                                    <div className="cust-info">
                                        <div className="site-content">
                                            <label className="meter-data-header" >Meter Zone Name :  </label>
                                            {
                                                this.state.meterData.pageName1 === "Route Meter Mapping" ? (
                                                    <label className="ml-3">{this.state.meterData.routeItem.customer_name != null ? this.state.meterData.routeItem.customer_name : "NA"}</label>
                                                ) : (
                                                    this.state.meterData.pageName === "Meter" ? (
                                                        <label className="ml-3">{this.state.meterData.rowItem.customer_name != null ? this.state.meterData.rowItem.customer_name : "NA"}</label>
                                                    ) : (
                                                        this.state.meterData.pageName === FLOW_READINGS_PAGENAME ||  this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME || this.state.meterData.pageName === "AMI Readings" || this.state.meterData.pageName === LEVEL_READINGS_PAGENAME  || this.state.meterData.pageName === OHT_READINGS_PAGENAME ? (
                                                            <label className="ml-3">{this.state.zone}</label>
                                                        ) : (
                                                            <label className="ml-3">{"NA"}</label>
                                                        )
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="site-info">
                                        <div className="content">
                                            <label className="meter-data-header" >Meter Subzone Name :  </label>
                                            {
                                                this.state.meterData.pageName1 === "Route Meter Mapping" ? (
                                                    <label className="ml-3">{this.state.meterData.routeItem.customer_address1 !== null ? (`${this.state.meterData.routeItem.customer_address1}, ${this.state.meterData.routeItem.customer_address2},${this.state.meterData.routeItem.street}, ${this.state.meterData.routeItem.city}, ${this.state.meterData.routeItem.pin_code}`) : "NA"}</label>

                                                ) : (
                                                    this.state.meterData.pageName === "Meter" ? (
                                                        <label className="ml-3">{this.state.meterData.rowItem.customer_address1 !== null ? (`${this.state.meterData.rowItem.customer_address1}, ${this.state.meterData.rowItem.customer_address2}, ${this.state.meterData.rowItem.street}, ${this.state.meterData.rowItem.city}, ${this.state.meterData.rowItem.pin_code}`) : "NA"}</label>
                                                    ) : (
                                                        this.state.meterData.pageName === FLOW_READINGS_PAGENAME  ||  this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME || this.state.meterData.pageName === "AMI Readings" || this.state.meterData.pageName === LEVEL_READINGS_PAGENAME || this.state.meterData.pageName === OHT_READINGS_PAGENAME  ? (
                                                            <label className="ml-3">{this.state.subZone}</label>
                                                        ) : (
                                                            <label className="ml-3">{"NA"}</label>
                                                        )
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div></div>
                        </div>
                        {/* <div className="mr-5 sync-wrapper sync-responsive"> */}
                            {/* {
                                this.state.isSyncVisible ? (
                                    <>
                                        <div className="ml-3">
                                            <i className={`${REFRESH_ICON} ${this.state.onnileIconClass} text-center mr-4 rotate`} />
                                        </div>
                                        <label className={`${this.state.onnileIconClass}`}>Syncing</label>
                                    </>
                                ) : (
                                    <label className={`disable-icon`}>Pause...</label>
                                )
                            } */}
{/* 
                        </div> */}
                        <div className="mr-5 sync-wrapper sync-responsive">
                         <div className="live-sync-info">
                                                        <i
                                                            onClick={this.handleRefresh}
                                                            className={`${REFRESH_ICON}`}
                                                        ></i>
                                                        {/* <label className={`${this.state.liveSyncIconClass}`}>Refresh...</label> */}
                                                    </div>
                    </div>
                    </div>
                    <div className="mt-4 border list-table-div" style={{ marginBottom: "10%" }}>
                        {
                            this.state.meterData.pageName === "AMI Readings" && (
                                <div>
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.startDate}
                                                        onChange={this.handleStartDateChange}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.endDate}
                                                        onChange={this.handleEndDateChange}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="addButton">
                                            <button id="button" className="brand-button report-button" onClick={this.getAMIReportReadings}>Get Report</button>
                                            <button
                                                id="download-excel-button"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.exportToXLSXAmiReadings}>Download as XLS
                                    </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {   this.state.materialtableLoading ? (
    <div className="pie-chart-spinner-wrapper-loading">
      <GraphLoader />
    </div>
  ) :(
                           ( this.state.readingList.length > 0 || this.state.readingRadarList.length > 0) ? ( 
                                this.state.meterData.pageName === FLOW_READINGS_PAGENAME ||   this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME || this.state.meterData.pageName === "AMI Readings" || this.state.meterData.pageName === LEVEL_READINGS_PAGENAME ||  this.state.meterData.pageName === OHT_READINGS_PAGENAME  ? (
                                    <ReadingListTable readingList={this.state.readingList} meterApplicationType={this.state.meterApplicationType} readingRadarList={this.state.readingRadarList} pageName={this.state.meterData.pageName} />
                                ) : (
                                    <MaterialTable
                                        columns={[
                                            // {
                                            //     title: "Serial Number", field: "meter_serial_no",
                                            //     cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                            // },
                                            {
                                                title: "Route", field: "route_name1",
                                                cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 100 },
                                                sorting: false, filtering: true
                                            },
                                            {
                                                title: "Aqualink Device Id", field: "sird_device_id",
                                                cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14 },
                                                sorting: false
                                            },
                                            {
                                                title: "Reader", field: "assigned_user_id",
                                                cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14 }
                                            },
                                            {
                                                title: "Unit", field: "unit",
                                                cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14 }
                                            },
                                            {
                                                title: "Meter Status", field: "status",
                                                cellStyle: { cellWidth: '14%', color: '#808080', fontSize: 14 }
                                            },
                                            {
                                                title: "Reading Status", field: "meter_status",
                                                cellStyle: { cellWidth: '14%', color: '#808080', fontSize: 14 }
                                            },
                                            {
                                                title: "Alarm Type", field: "alarm_type1",
                                                cellStyle: { cellWidth: '14%', color: '#808080', fontSize: 14, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 100 }, filtering: true
                                            },
                                            {
                                                title: "Date", field: "receive_date_time",
                                                cellStyle: {
                                                    cellWidth: '14%', color: '#808080', fontSize: 14,
                                                    textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 100
                                                }
                                            },
                                            {
                                                title: "Reading", field: "meter_reading",
                                                cellStyle: { cellWidth: '14%', color: '#808080', fontSize: 14 }
                                            },
                                            {
                                                title: "Photo", field: "photo",
                                                cellStyle: { cellWidth: '5%', color: '#808080', fontSize: 14 }, filtering: false
                                            }
                                        ]}
                                        data={
                                            this.state.readingList.map((item, index) => {
                                                let readingStatusClass = "unread";
                                                let meterStatusClass = "text-success";

                                                if (item.meter_status === "Manual") {
                                                    readingStatusClass = "manual";
                                                }
                                                else if (item.meter_status === "Auto+Alarm") {
                                                    readingStatusClass = "alarm";
                                                }
                                                else if (item.meter_status === "Auto Read") {
                                                    readingStatusClass = "read";
                                                }

                                                return (
                                                    {
                                                        meter_serial_no: item.meter_serial_no,
                                                        route_name1: <Tooltip placement="bottom-start" title={<span style={{ fontSize: "12px", color: "white" }}>{this.state.routeName} </span>}><span>{this.state.routeName}</span></Tooltip>,
                                                        route_name: this.state.routeName,
                                                        sird_device_id: item.sird_device_id,
                                                        assigned_user_id: item.assigned_user_id,
                                                        unit: <span style={{ textTransform: 'none' }}>{item.unit !== null ? (item.unit === "0" || item.unit === "m³" ? "m³" : item.unit === "1" || item.unit === "L" ? "L" : item.unit === "2" || item.unit === "GAL" ? "GAL" : item.unit === "3" || item.unit === "ft3" ? "ft3" : "NA") : "NA"}</span>,
                                                        status: <span className={`${meterStatusClass}`}>{this.renderStatus(item.meter_serial_no)}</span>,
                                                        meter_status: <span className={`${readingStatusClass}`}>{item.meter_status}</span>,
                                                        alarm_type1: <Tooltip placement="bottom-start" title={<span style={{ fontSize: "12px", color: "white" }}>{validateBitStatusAlarms(item.alarm_type)} </span>}><span>{validateBitStatusAlarms(item.alarm_type)}</span></Tooltip>,
                                                        alarm_type: item.alarm_type ? item.alarm_type : "None",
                                                        receive_date_time: <Tooltip placement="bottom-start" title={<span style={{ fontSize: "12px", color: "white" }}>{validateIsoDateFormat(item.receive_date_time) ? defaultFormatDateTime(item.receive_date_time) : item.receive_date_time} </span>}><span>{validateIsoDateFormat(item.receive_date_time) ? defaultFormatDateTime(item.receive_date_time) : item.receive_date_time}</span></Tooltip>,
                                                        meter_reading: item.meter_reading ? item.meter_reading : "NA",
                                                        _id: item._id,
                                                        photo: <i className={(item.reading_image !== "" && item.reading_image !== undefined) ? `${CAMERA_ICON} camera-icon` : `${CAMERA_ICON} gray-icon`} title="View Photo" onClick={() => this.viewImage(item.reading_image)}></i>
                                                    }
                                                )
                                            })
                                        }
                                        options={{
                                            actionsColumnIndex: -1,
                                            pageSize: 25,
                                            pageSizeOptions: [25, 50, 75, 100],
                                            headerStyle: {
                                                color: '#999998',
                                                fontWeight: 'bolder',
                                                fontSize: 15
                                            },
                                            filtering: true,
                                            sorting: true,
                                            exportButton: true,
                                            exportAllData: true,
                                            exportFileName: "Meter Reading Data"
                                        }}
                                    />
                                )
                            ) : (
                                <div className="text-center pt-2"> No Records Found!</div>
                            )
                        )
                        }
                        {
                            this.state.viewImage && (
                                <>
                                    <div className="custom_modal">
                                        <div className="modal_body">
                                            <div className="row">
                                                <div className="col-md-10">
                                                    <h4 className="modal_title pagetitle">View Meter Image</h4>
                                                </div>
                                                <div className="col-md-2">
                                                    <button type="button" className="close text-right" style={{ fontSize: 20 }} onClick={(e) => this.setState({ viewImage: false })}>&times;</button>
                                                </div>
                                                {
                                                    (this.state.imgSrc.includes("png") || this.state.imgSrc.includes("jpg") || this.state.imgSrc.includes("jpeg")) ? (
                                                        <embed src={this.state.imgSrc} title="photo" width="100%" height="auto" />
                                                    ) : (
                                                        <embed style={{ height: '400px' }} src={this.state.imgSrc} title="photo" width="100%" height="auto" />
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    </div>
                    {/* {
                        this.state.meterData.pageName === FLOW_READINGS_PAGENAME && (
                            <div >
                                <div className="report-section"><span>READINGS REPORT AND GRAPH GENERATE</span></div>
                                <div className="totalizer-and-flowrate-header">
                                    <div className="report-section-one">TOTALIZER</div>
                                    <div className="report-section-two">FLOWRATE</div>
                                </div>

                                <div className="live-sync-icon-and-text-container totalizer-and-flowrate">
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div totalizer-date-div ">
                                        <div className="row">
                                            <div className="addUser ">
                                                <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.totalizerGenerateValue}
                                                    placeholder="Select Date"
                                                    options={this.state.excelAndGraphGenerateOptionList}
                                                    onChange={this.totalizerGenerateChangeHandler}
                                                    menuPlacement="bottom"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.totalizerGenerateValue}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.totalizerGenerateValue.value === "daily" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.totalizerGenerateValue.value === "weekly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.totalizerGenerateValue.value === "monthly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.totalizerGenerateValue.value === "custom" && (
                                                <div className="row">
                                                    <div className="addUser ">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.startDate}
                                                                onChange={this.handleStartDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser ">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.endDate}
                                                                onChange={this.handleEndDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="addButton">
                                            <button id="button" className="report-button-space" onClick={this.getTotalizerReportReadings}>GET REPORT</button>
                                            <button
                                                id="download-excel-button-totalizer"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.totalizerExportToXLSX}>Download as XLS
                                         </button>
                                        </div>
                                    </div>
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div flowrate-date-div">
                                        <div className="row">
                                            <div className="addUser ">
                                                <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.flowrateGenerateValue}
                                                    placeholder="Select Date"
                                                    options={this.state.excelAndGraphGenerateOptionList}
                                                    onChange={this.flowrateGenerateChangeHandler}
                                                    menuPlacement="bottom"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.flowrateGenerateValue}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.flowrateGenerateValue.value === "daily" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                          {
                                            this.state.flowrateGenerateValue.value === "weekly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                          {
                                            this.state.flowrateGenerateValue.value === "monthly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.flowrateGenerateValue.value === "custom" && (
                                                <div className="row">
                                                    <div className="addUser ">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.startDate}
                                                                onChange={this.handleStartDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser ">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.endDate}
                                                                onChange={this.handleEndDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="addButton">
                                            <button id="button" className="report-button-space" onClick={this.getFlowrateReportReadings}>GET REPORT</button>
                                            <button
                                                id="download-excel-button-flowrate"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.flowrateExportToXLSX}>Download as XLS
                                         </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    } */}
                    {
                        this.state.meterData.pageName === OHT_READINGS_PAGENAME && (
                            <>
                            <div>
                                <div className="report-section"><span>READINGS REPORT AND GRAPH GENERATE</span></div>
                                <div className="totalizer-and-flowrate-header">
                                    <div className="report-section-one">TOTALIZER</div>
                                    <div className="report-section-two">FLOWRATE</div>
                                </div>

                                {/* Parent container for the two flex items */}
                                <div className="live-sync-icon-and-text-container totalizer-and-flowrate">
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div totalizer-date-div ">
                                        <div className="row">
                                            <div className="addUser ">
                                                <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.totalizerGenerateValue}
                                                    placeholder="Select Date"
                                                    options={this.state.excelAndGraphGenerateOptionList}
                                                    onChange={this.totalizerGenerateChangeHandler}
                                                    menuPlacement="bottom"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.totalizerGenerateValue}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.totalizerGenerateValue.value === "daily" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.totalizerGenerateValue.value === "weekly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.totalizerGenerateValue.value === "monthly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.totalizerGenerateValue.value === "custom" && (
                                                <div className="row">
                                                    <div className="addUser ">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.startDate}
                                                                onChange={this.handleStartDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser ">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.endDate}
                                                                onChange={this.handleEndDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="addButton">
                                            <button id="button" className="report-button-space" onClick={this.getOhtTotalizerReportReadings}>GET REPORT</button>
                                            <button
                                                id="download-excel-button-totalizer"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.ohtTotalizerExportToXLSX}>Download as XLS
                                         </button>
                                        </div>
                                        
                                    </div>
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div flowrate-date-div">
                                        <div className="row">
                                            <div className="addUser ">
                                                <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.flowrateGenerateValue}
                                                    placeholder="Select Date"
                                                    options={this.state.excelAndGraphGenerateOptionList}
                                                    onChange={this.flowrateGenerateChangeHandler}
                                                    menuPlacement="bottom"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.flowrateGenerateValue}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.flowrateGenerateValue.value === "daily" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                          {
                                            this.state.flowrateGenerateValue.value === "weekly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                          {
                                            this.state.flowrateGenerateValue.value === "monthly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.flowrateGenerateValue.value === "custom" && (
                                                <div className="row">
                                                    <div className="addUser ">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.startDate}
                                                                onChange={this.handleStartDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser ">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.endDate}
                                                                onChange={this.handleEndDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="addButton">
                                            <button id="button" className="report-button-space" onClick={this.getOhtFlowrateReportReadings}>GET REPORT</button>
                                            <button
                                                id="download-excel-button-flowrate"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.OhtFlowrateExportToXLSX}>Download as XLS
                                         </button>
                                        </div>
                                    </div>
                               
                                </div>
                                    <div className="live-sync-icon-and-text-container">
                                        <div className="totalizer-graph">
                                            <div className="line-graph-header">TOTALIZER</div>
                                            {this.state.ohtFlowTotalizerGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                    <GraphLoader />
                                                </div>
                                            ) : (
                                                <LineChartTotalizer data={this.state.ohtTotalizerGraphList} />
                                            )}
                                        </div>
                                        <div className="flowrate-graph">
                                            <div className="line-graph-header">FLOWRATE</div>
                                            {this.state.ohtFlowFlowrateGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                    <GraphLoader />
                                                </div>
                                            ) : (
                                                <LineChartFlowrate data={this.state.ohtFlowrateGraphList} />
                                            )}
                                        </div>
                                    </div>
                            </div>
                            
                            
                            <div>
                                <div className="totalizer-and-flowrate-header">
                                    <div className="report-section-one">PRESSURE</div>
                                    <div className="report-section-two">LEVEL</div>
                                </div>

                                {/* Parent container for the two flex items */}
                                <div className="live-sync-icon-and-text-container totalizer-and-flowrate">
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div totalizer-date-div ">
                                        <div className="row">
                                            <div className="addUser ">
                                                <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.ohtPressureGenerateValue}
                                                    placeholder="Select Date"
                                                    options={this.state.excelAndGraphGenerateOptionList}
                                                    onChange={this.ohtPressureGenerateChangeHandler}
                                                    menuPlacement="bottom"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.ohtTotalizerGenerateValue}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.ohtPressureGenerateValue.value === "daily" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.ohtPressureGenerateValue.value === "weekly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.ohtPressureGenerateValue.value === "monthly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.ohtPressureGenerateValue.value === "custom" && (
                                                <div className="row">
                                                    <div className="addUser ">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.startDate}
                                                                onChange={this.handleStartDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser ">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.endDate}
                                                                onChange={this.handleEndDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="addButton">
                                            <button id="button" className="report-button-space" onClick={this.getOhtPressureReportReadings}>GET REPORT</button>
                                            <button
                                                id="download-excel-button-totalizer"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.ohtPressureExportToXLSX}>Download as XLS
                                         </button>
                                        </div>
                                    </div>
                                    <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div flowrate-date-div">
                                        <div className="row">
                                            <div className="addUser ">
                                                <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.ohtLevelGenerateValue}
                                                    placeholder="Select Date"
                                                    options={this.state.excelAndGraphGenerateOptionList}
                                                    onChange={this.ohtLevelGenerateChangeHandler}
                                                    menuPlacement="bottom"
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.ohtChangeGenerateValue}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.ohtLevelGenerateValue.value === "daily" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.dailyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                          {
                                            this.state.ohtLevelGenerateValue.value === "weekly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.weeklyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                          {
                                            this.state.ohtLevelGenerateValue.value === "monthly" && (
                                                <div className="row">
                                                    <div className="addUser">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyStartDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.monthlyEndDate}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            this.state.ohtLevelGenerateValue.value === "custom" && (
                                                <div className="row">
                                                    <div className="addUser ">
                                                        <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.startDate}
                                                                onChange={this.handleStartDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="addUser ">
                                                        <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                        <div className="calender-div">
                                                            <span className="icon fa-calendar" />
                                                            <DatePicker className="form-control brand-font p-3"
                                                                selected={this.state.endDate}
                                                                onChange={this.handleEndDateChange}
                                                                timeIntervals={1}
                                                                timeCaption="time"
                                                                dateFormat="dd/MM/yyyy"
                                                                maxDate={this.state.maxEndDate}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className="addButton">
                                            <button id="button" className="report-button-space" onClick={this.getOhtLevelReportReadings}>GET REPORT</button>
                                            <button
                                                id="download-excel-button-flowrate"
                                                className="download-table-xls-button brandxls-button download-button"
                                                onClick={this.OhtLevelExportToXLSX}>Download as XLS
                                         </button>
                                        </div>
                                    </div>
                                </div>
                                    <div className="live-sync-icon-and-text-container">
                                        <div className="totalizer-graph">
                                            <div className="line-graph-header">PRESSURE</div>
                                            {this.state.ohtPressureGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                    <GraphLoader />
                                                </div>
                                            ) : (
                                                <LineChartTotalizer data={this.state.ohtPressureGraphList} />
                                            )}
                                        </div>
                                        <div className="flowrate-graph">
                                            <div className="line-graph-header">LEVEL</div>
                                            {this.state.ohtLevelGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                    <GraphLoader />
                                                </div>
                                            ) : (
                                                <LineChartFlowrate data={this.state.ohtLevelGraphList} />
                                            )}
                                        </div>
                                    </div>
                            </div>
                         </>
                        )
                    }


                    
                    {this.state.meterData.pageName === LEVEL_READINGS_PAGENAME && (
                        <div>
                            <div className="report-section">
                                <span>READINGS REPORT AND GRAPH GENERATE</span>
                            </div>

                            <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                <div className="row">
                                    <div className="addUser">
                                        <label className="form-label">
                                            Select Date To Generate Excel And Graph{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="site-select-dropdown"
                                            value={this.state.levelExcelGenerateValue}
                                            placeholder="Select Date"
                                            options={this.state.excelAndGraphGenerateOptionList}
                                            onChange={this.levelGenerateChangeHandler}
                                            menuPlacement="bottom"
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.levelExcelGenerateValue}
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.levelExcelGenerateValue.value === "daily" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.dailyStartDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.dailyEndDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    this.state.levelExcelGenerateValue.value === "weekly" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.weeklyStartDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.weeklyEndDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    this.state.levelExcelGenerateValue.value === "monthly" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.monthlyStartDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.monthlyEndDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {this.state.levelExcelGenerateValue.value === "custom" && (
                                    <div className="row">
                                        <div className="addUser">
                                            <label className="form-label">
                                                From Date <span className="text-danger">*</span>
                                            </label>
                                            <div className="calender-div">
                                                <span className="icon fa-calendar" />
                                                <DatePicker
                                                    className="form-control brand-font p-3"
                                                    selected={this.state.startDate}
                                                    onChange={this.handleStartDateChange}
                                                    timeIntervals={1}
                                                    timeCaption="time"
                                                    dateFormat="dd/MM/yyyy"
                                                    maxDate={this.state.maxEndDate}
                                                />
                                            </div>
                                        </div>
                                        <div className="addUser">
                                            <label className="form-label">
                                                To Date <span className="text-danger">*</span>
                                            </label>
                                            <div className="calender-div">
                                                <span className="icon fa-calendar" />
                                                <DatePicker
                                                    className="form-control brand-font p-3"
                                                    selected={this.state.endDate}
                                                    onChange={this.handleEndDateChange}
                                                    timeIntervals={1}
                                                    timeCaption="time"
                                                    dateFormat="dd/MM/yyyy"
                                                    maxDate={this.state.maxEndDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="addButton">
                                    <button
                                        id="button"
                                        className="brand-button report-button"
                                        onClick={this.getlevelReportReadings}
                                    >
                                        Get Report
                              </button>
                                    <button
                                        id="download-excel-button-level"
                                        className="download-table-xls-button brandxls-button download-button"
                                        onClick={this.levelExportToXLSX}
                                    >
                                        Download as XLS
                              </button>
                                </div>
                            </div>
                        </div>
                    )}
                     {this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME && (
                        <div>
                            <div className="report-section">
                                <span>READINGS REPORT AND GRAPH GENERATE</span>
                            </div>

                            <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                <div className="row">
                                    <div className="addUser">
                                        <label className="form-label">
                                            Select Date To Generate Excel And Graph{" "}
                                            <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            className="site-select-dropdown"
                                            value={this.state.pressureExcelGenerateValue}
                                            placeholder="Select Date"
                                            options={this.state.excelAndGraphGenerateOptionList}
                                            onChange={this.pressureGenerateChangeHandler}
                                            menuPlacement="bottom"
                                        />
                                        <div className="text-danger error-msg">
                                            {this.state.error.pressureExcelGenerateValue}
                                        </div>
                                    </div>
                                </div>
                                {/* {
                                    this.state.pressureExcelGenerateValue.value === "daily" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.dailyStartDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.dailyEndDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    this.state.pressureExcelGenerateValue.value === "weekly" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.weeklyStartDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.weeklyEndDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    this.state.pressureExcelGenerateValue.value === "monthly" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">From Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.monthlyStartDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">To Date <span className="text-danger">*</span></label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker className="form-control brand-font p-3"
                                                        selected={this.state.monthlyEndDate}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                } */}
                                {this.state.pressureExcelGenerateValue.value === "custom" && (
                                    <div className="row">
                                        <div className="addUser">
                                            <label className="form-label">
                                                From Date <span className="text-danger">*</span>
                                            </label>
                                            <div className="calender-div">
                                                <span className="icon fa-calendar" />
                                                <DatePicker
                                                    className="form-control brand-font p-3"
                                                    selected={this.state.startDate}
                                                    onChange={this.handleStartDateChange}
                                                    timeIntervals={1}
                                                    timeCaption="time"
                                                    dateFormat="dd/MM/yyyy"
                                                    maxDate={this.state.maxEndDate}
                                                />
                                            </div>
                                        </div>
                                        <div className="addUser">
                                            <label className="form-label">
                                                To Date <span className="text-danger">*</span>
                                            </label>
                                            <div className="calender-div">
                                                <span className="icon fa-calendar" />
                                                <DatePicker
                                                    className="form-control brand-font p-3"
                                                    selected={this.state.endDate}
                                                    onChange={this.handleEndDateChange}
                                                    timeIntervals={1}
                                                    timeCaption="time"
                                                    dateFormat="dd/MM/yyyy"
                                                    maxDate={this.state.maxEndDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="addButton">
                                    <button
                                        id="button"
                                        className="brand-button report-button"
                                        onClick={this.getPressureReportReadings}
                                    >
                                        Get Report
                              </button>
                                    <button
                                        id="download-excel-button-pressure"
                                        className="download-table-xls-button brandxls-button download-button"
                                        onClick={this.pressureExportToXLSX}
                                    >
                                        Download as XLS
                              </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <div >
                        {/* {
                            this.state.meterData.pageName === FLOW_READINGS_PAGENAME && (
                                <>
                                    <div className="live-sync-icon-and-text-container">
                                        <div className="totalizer-graph">
                                            <div className="line-graph-header">TOTALIZER</div>
                                            {this.state.flowTotalizerGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                <GraphLoader />
                                                </div>
                                              ) :(
                                            <LineChartTotalizer data={this.state.totalizerGraphList} unit={"m³"} reportType={this.state.totalizerGenerateValue.label} monthValue={this.state.monthSelectedValue} fromDate={moment(this.state.startDate)} toDate={moment(this.state.endDate)} />
                                            )}
                                        </div>
                                        <div className="flowrate-graph">
                                            <div className="line-graph-header">FLOWRATE</div>
                                            {this.state.flowFlowrateGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                <GraphLoader />
                                                </div>
                                              ) :(
                                            <LineChartFlowrate data={this.state.flowrateGraphList} />
                                            )}
                                        </div>
                                    </div>

                                </>
                            )} */}

                        {/* {
                            this.state.meterData.pageName === OHT_READINGS_PAGENAME && (
                                <>
                                    <div className="live-sync-icon-and-text-container">
                                        <div className="totalizer-graph">
                                            <div className="line-graph-header">TOTALIZER</div>
                                            {this.state.ohtFlowTotalizerGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                    <GraphLoader />
                                                </div>
                                            ) : (
                                                <LineChartTotalizer data={this.state.ohtTotalizerGraphList} />
                                            )}
                                        </div>
                                        <div className="flowrate-graph">
                                            <div className="line-graph-header">FLOWRATE</div>
                                            {this.state.ohtFlowFlowrateGraphLoading ? (
                                                <div className="line-chart-graph-height">
                                                    <GraphLoader />
                                                </div>
                                            ) : (
                                                <LineChartFlowrate data={this.state.ohtFlowrateGraphList} />
                                            )}
                                        </div>
                                    </div>

                                </>
                            )} */}

                        {this.state.meterData.pageName === FLOW_READINGS_PAGENAME && (
                            <div>
                                <div className="report-section">
                                    <span>TOTALIZER REPORT AND GRAPH GENERATE</span>
                                </div>

                                <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                    <div className="row">
                                        <div className="addUser ">
                                            <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                            <Select
                                                className="site-select-dropdown"
                                                value={this.state.totalizerGenerateValue}
                                                placeholder="Select Date"
                                                options={this.state.excelAndGraphGenerateOptionList}
                                                onChange={this.totalizerGenerateChangeHandler}
                                                menuPlacement="bottom"
                                            />
                                            <div className="text-danger error-msg">
                                                {this.state.error.totalizerGenerateValue}
                                            </div>
                                        </div>
                                        {this.state.totalizerGenerateValue.label === 'Monthly' && (
                                            <div className="addUser">
                                                <label className="form-label">Select Month  <span className="text-danger">*</span></label>
                                                <Select
                                                    className="site-select-dropdown"
                                                    value={this.state.monthSelectedValue}
                                                    placeholder="Select month"
                                                    options={this.state.monthOptions}
                                                    onChange={this.monthChangeHandler}
                                                    menuPlacement="bottom"
                                                    isSearchable={true}
                                                    isClearable={true}
                                                />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.monthSelectedValue}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {this.state.totalizerGenerateValue.value === "custom" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">
                                                    From Date <span className="text-danger">*</span>
                                                </label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker
                                                        className="form-control brand-font p-3"
                                                        selected={this.state.startDate}
                                                        onChange={this.handleStartDateChange}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">
                                                    To Date <span className="text-danger">*</span>
                                                </label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker
                                                        className="form-control brand-font p-3"
                                                        selected={this.state.endDate}
                                                        onChange={this.handleEndDateChange}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="addButton">
                                        <button
                                            id="button"
                                            className="brand-button report-button"
                                            onClick={this.getTotalizerReportReadings}
                                        >
                                            Get Report
                                        </button>
                                        <button
                                            id="download-excel-button-totalizer"
                                            className="download-table-xls-button brandxls-button download-button"
                                            onClick={this.totalizerExportToXLSX}
                                        >
                                            Download as XLS
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                           {
                            this.state.meterData.pageName === FLOW_READINGS_PAGENAME && (
                                <div className="live-sync-icon-and-text-container-level-meter-graph  ">
                                    <div className="totalizer-graph">
                                        {/* <div className="line-graph-header">TOTALIZER</div> */}
                                        {this.state.flowTotalizerGraphLoading ? (
                                            <div className="line-chart-graph-height">
                                                <GraphLoader />
                                            </div>
                                        ) : (
                                            <LineChartTotalizer data={this.state.totalizerGraphList} unit={"m³"} reportType={this.state.totalizerGenerateValue.label} monthValue={this.state.monthSelectedValue} fromDate={moment(this.state.startDate)} toDate={moment(this.state.endDate)} />
                                        )}
                                    </div>
                                </div>
                            )
                        }

                        {this.state.meterData.pageName === FLOW_READINGS_PAGENAME && (
                            <div>
                                <div className="report-section">
                                    <span>FLOWRATE REPORT AND GRAPH GENERATE</span>
                                </div>

                                <div className="pt-4 mt-4 mb-5 pb-4 border list-table-div">
                                    <div className="row">
                                        <div className="addUser ">
                                            <label className="form-label">Select Date <span className="text-danger">*</span></label>
                                            <Select
                                                className="site-select-dropdown"
                                                value={this.state.flowrateGenerateValue}
                                                placeholder="Select Date"
                                                options={this.state.flowrateSelectOption}
                                                onChange={this.flowrateGenerateChangeHandler}
                                                menuPlacement="bottom"
                                            />
                                            <div className="text-danger error-msg">
                                                {this.state.error.flowrateGenerateValue}
                                            </div>
                                        </div>
                                    </div>

                                    {this.state.flowrateGenerateValue.value === "custom" && (
                                        <div className="row">
                                            <div className="addUser">
                                                <label className="form-label">
                                                    From Date <span className="text-danger">*</span>
                                                </label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker
                                                        className="form-control brand-font p-3"
                                                        selected={this.state.startDate}
                                                        onChange={this.handleStartDateChange}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                            <div className="addUser">
                                                <label className="form-label">
                                                    To Date <span className="text-danger">*</span>
                                                </label>
                                                <div className="calender-div">
                                                    <span className="icon fa-calendar" />
                                                    <DatePicker
                                                        className="form-control brand-font p-3"
                                                        selected={this.state.endDate}
                                                        onChange={this.handleEndDateChange}
                                                        timeIntervals={1}
                                                        timeCaption="time"
                                                        dateFormat="dd/MM/yyyy"
                                                        maxDate={this.state.maxEndDate}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="addButton">
                                        <button
                                            id="button"
                                            className="brand-button report-button"
                                            onClick={this.getFlowrateReportReadings}
                                        >
                                            Get Report
                                        </button>
                                        <button
                                            id="download-excel-button-flowrate"
                                            className="download-table-xls-button brandxls-button download-button"
                                            onClick={this.flowrateExportToXLSX}
                                        >
                                            Download as XLS
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}


                        {
                            this.state.meterData.pageName === FLOW_READINGS_PAGENAME && (
                                <div className="live-sync-icon-and-text-container-level-meter-graph  ">
                                    <div className="flowrate-graph">
                                        {/* <div className="line-graph-header">FLOWRATE</div> */}
                                        {this.state.flowFlowrateGraphLoading ? (
                                            <div className="line-chart-graph-height">
                                                <GraphLoader />
                                            </div>
                                        ) : (
                                            <LineChartFlowrate data={this.state.flowrateGraphList} />
                                        )}
                                    </div>
                                </div>
                            )
                        }


                        {
                            this.state.meterData.pageName === LEVEL_READINGS_PAGENAME && (
                                <div className="live-sync-icon-and-text-container-level-meter-graph  ">
                                    {/* <div className="line-graph-header">Level</div> */}
                                    <div className="totalizer-graph">
                                        <LevellineChart data={this.state.levelGraphList} />
                                    </div>
                                </div>
                            )
                        }
                        {
                            this.state.meterData.pageName === PRESSURE_READINGS_PAGENAME && (
                                <div className="live-sync-icon-and-text-container-level-meter-graph  ">
                                    {/* <div className="line-graph-header">Pressure</div> */}
                                    <div className="totalizer-graph">
                                        <PressurelineChart data={this.state.pressureGraphList} />
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            )
        }
    }
}

export default MeterReadingPage